// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { FaCalendarAlt, FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
// import ACOrderForm from "./ACOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import heroImage from "../images/ac-service.png";
// import "./acserviceStyle.css";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const AcService = () => {
//   const { t } = useTranslation();
//   const [ratingData, setRatingData] = useState({ reviewCount: 0, avgRating: 0 });
//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );
//   const [useSameServitor, setUseSameServitor] = useState(false);
//   const [prevServitorName, setPrevServitorName] = useState("");
//   const [acType, setAcType] = useState("");
//   const [acTon, setAcTon] = useState("");
//   const [newSetup, setNewSetup] = useState(0);
//   const [installation, setInstallation] = useState(0);
//   const [uninstallation, setUninstallation] = useState(0);
//   const [gasRefill, setGasRefill] = useState(0);
//   const [cleaning, setCleaning] = useState(0);
//   const [issueCheckup, setIssueCheckup] = useState(false);
//   const [remarks, setRemarks] = useState("");
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);


//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };
//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setAcType(prevOrder.acType || "");
//       setAcTon(prevOrder.acTon || "");
//       setNewSetup(prevOrder.new_setup || 0);
//       setInstallation(prevOrder.installation || 0);
//       setUninstallation(prevOrder.uninstallation || 0);
//       setGasRefill(prevOrder.gas_refill || 0);
//       setCleaning(prevOrder.cleaning || 0);
//       setIssueCheckup(prevOrder.issue_checkup || false);
//       setRemarks(prevOrder.remarks || "");
//     }
//   }, [rebookState, prevOrder]);

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally { setLoading(false); }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       const acKey = data["ac service"] || data["AC Service"] || {};
//   //       setRatingData({
//   //         reviewCount: acKey.reviewCount || 0,
//   //         avgRating: acKey.avgRating || 0,
//   //       });
//   //     })
//   //     .catch((err) => console.error("Failed to load ratings:", err));
//   // }, []);

//   useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         const acKey = data["ac service"] || data["AC Service"] || {};
//         setRatingData({
//           reviewCount: acKey.reviewCount || 0,
//           avgRating: acKey.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);


//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";
//     let startHour = startTime;
//     let startMinute = 0;
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return [];
//       }
//       if (currentHour >= startTime) {
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }
//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

// //   const calculatePrice = () => {
// //     const ton = parseFloat(acTon || "0") || 0;
// //     const tonMult = ton >= 2 ? 1.3 : ton >= 1.5 ? 1.15 : ton >= 1 ? 1.0 : 1.0;
// //     let price = 100;
// //     price += newSetup * 800;
// //     price += installation * 600;
// //     price += uninstallation * 400;
// //     price += gasRefill * 1200;
// //     price += cleaning * 300;
// //     if (issueCheckup) price += 100;
// //     return Math.round(price * tonMult);
// //   };

//     const PRICE_TABLE = {
//     newSetup: { "1": 2000, "1.5": 2000, "2": 2500, "2.5": 3000 },
//     installation: { "1": 1800, "1.5": 1800, "2": 2200, "2.5": 2600 },
//     uninstallation: { "1": 700, "1.5": 700, "2": 900, "2.5": 1000 },
//     gasRefill: { "1": 1500, "1.5": 1600, "2": 2000, "2.5": 2400 },
//     cleaning: { "1": 550, "1.5": 550, "2": 650, "2.5": 700 },
//     issueCheckup: 300, // flat add-on
//     };

//     function resolveTonKey(rawTon) {
//     // Normalize to our table keys; default to "1"
//     const t = String(rawTon || "1");
//     return ["1", "1.5", "2", "2.5"].includes(t) ? t : "1";
//     }

//     // REPLACE your calculatePrice with this:
//     const calculatePrice = () => {
//     const tonKey = resolveTonKey(acTon);

//     const line = (count, table) =>
//         (Number(count) || 0) * (PRICE_TABLE[table][tonKey] || 0);

//     let price = 0;
//     price += line(newSetup, "newSetup");
//     price += line(installation, "installation");
//     price += line(uninstallation, "uninstallation");
//     price += line(gasRefill, "gasRefill");
//     price += line(cleaning, "cleaning");

//     if (issueCheckup) price += PRICE_TABLE.issueCheckup;

//     return Math.round(price);
//     };

//   const handleGetService = (e) => {
//     e.preventDefault();
//     const time = e.target.time.value;
//     const dateStr = selectedDate ? selectedDate.toISOString().split("T")[0] : "";
//     const formDetails = {
//       acType,
//       acTon,
//       newSetup, // Changed from new_setup
//       installation,
//       uninstallation,
//       gasRefill, // Changed from gas_refill
//       cleaning,
//       issueCheckup,
//       remarks,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//       useSameServitor,
//       servitor_id: useSameServitor ? prevOrder.servitor_id : undefined,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   const handleOrderSubmit = (orderData) => {
//     console.log("Order Data:", orderData);
//     setShowOrderForm(false);
//     setAcType("");
//     setAcTon("");
//     setNewSetup(0);
//     setInstallation(0);
//     setUninstallation(0);
//     setGasRefill(0);
//     setCleaning(0);
//     setIssueCheckup(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const { t } = useTranslation();
//     const handleIncrement = () => {
//       if (value < max) {
//         setValue(value + 1);
//       }
//     };
//     const handleDecrement = () => {
//       if (value > min) {
//         setValue(value - 1);
//       }
//     };
//     const displayText = `${value} ${t(
//       value === 1 ? "ac.form.unit" : "ac.form.units"
//     )}`;
//     return (
//       <div className="ACService-plusMinusInput">
//         <button
//           type="button"
//           className="ACService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="ACService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="ACService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="ACService-container">
//         <Navbar />
//         <Loader show={loading} />
//         <div className="ACService-card">
//           <div className="ACService-hero">
//             <img src={heroImage} alt="AC Services Hero" />
//           </div>
//           <div className="ACService-header">
//             <h1>
//               {rebookState
//                 ? t("ac.header.rebook_title")
//                 : t("ac.header.title")}
//             </h1>
//             <div className="ACService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="ACService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("ac.reviewsLabel")}
//             </div>
//           </div>
//           <div className="ACService-categories">
//             <div className="ACService-category">
//               <h5>
//                 <span className="ACService-categoryIcon">❄️</span>
//                 {t("ac.categories.installation.title")}
//               </h5>
//               <p className="ACService-serviceDescription">
//                 {t("ac.categories.installation.description")}
//               </p>
//             </div>
//             <div className="ACService-category">
//               <h5>
//                 <span className="ACService-categoryIcon">🛠️</span>
//                 {t("ac.categories.maintenance.title")}
//               </h5>
//               <p className="ACService-serviceDescription">
//                 {t("ac.categories.maintenance.description")}
//               </p>
//             </div>
//             <div className="ACService-category">
//               <h5>
//                 <span className="ACService-categoryIcon">🏠</span>
//                 {t("ac.categories.home_service.title")}
//               </h5>
//               <p className="ACService-serviceDescription">
//                 {t("ac.categories.home_service.description")}
//               </p>
//             </div>
//           </div>
//           <form onSubmit={handleGetService} className="ACService-form">
//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-snowflake"></i>
//               {t("ac.form.ac_specifics")}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="acType">{t("ac.form.labels.ac_type")}</label> */}
//                 <label htmlFor="acType" className="tooltip-label">
//                                   {t("ac.form.labels.ac_type")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.ac_type.title")}
//                                     description={t("ac.tooltips.ac_type.description")}
//                                   />
//                                 </label>
//                 <select
//                   id="acType"
//                   value={acType}
//                   onChange={(e) => setAcType(e.target.value)}
//                   required
//                 >
//                   <option value="">{t("ac.form.placeholders.select")}</option>
//                   <option value="Inverter">{t("ac.form.ac_type_options.inverter")}</option>
//                   <option value="Non-Inverter">{t("ac.form.ac_type_options.non_inverter")}</option>
//                 </select>
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="acTon">{t("ac.form.labels.ac_ton")}</label> */}
//                 <label htmlFor="acTon" className="tooltip-label">
//                                   {t("ac.form.labels.ac_ton")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.ac_ton.title")}
//                                     description={t("ac.tooltips.ac_ton.description")}
//                                   />
//                                 </label>
//                 <select
//                   id="acTon"
//                   value={acTon}
//                   onChange={(e) => setAcTon(e.target.value)}
//                   required
//                 >
//                   <option value="">{t("ac.form.placeholders.select")}</option>
//                   <option value="1">1</option>
//                   <option value="1.5">1.5</option>
//                   <option value="2">2</option>
//                   <option value="2.5">2.5</option>
//                 </select>
//               </div>
//             </div>
//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-tools"></i>
//               {t("ac.form.setup_services_title")}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="newSetup">{t("ac.form.labels.new_setup")}</label> */}
//                 <label htmlFor="newSetup" className="tooltip-label">
//                                   {t("ac.form.labels.new_setup")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.new_setup.title")}
//                                     description={t("ac.tooltips.new_setup.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="newSetup"
//                   value={newSetup}
//                   setValue={setNewSetup}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="installation">{t("ac.form.labels.installation")}</label> */}
//                 <label htmlFor="installation" className="tooltip-label">
//                                   {t("ac.form.labels.installation")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.installation.title")}
//                                     description={t("ac.tooltips.installation.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="installation"
//                   value={installation}
//                   setValue={setInstallation}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="uninstallation">{t("ac.form.labels.uninstallation")}</label> */}
//                 <label htmlFor="uninstallation" className="tooltip-label">
//                                   {t("ac.form.labels.uninstallation")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.uninstallation.title")}
//                                     description={t("ac.tooltips.uninstallation.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="uninstallation"
//                   value={uninstallation}
//                   setValue={setUninstallation}
//                 />
//               </div>
//             </div>
//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-cogs"></i>
//               {t("ac.form.maintenance_services_title")}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="gasRefill">{t("ac.form.labels.gas_refill")}</label> */}
//                 <label htmlFor="gasRefill" className="tooltip-label">
//                                   {t("ac.form.labels.gas_refill")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.gas_refill.title")}
//                                     description={t("ac.tooltips.gas_refill.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="gasRefill"
//                   value={gasRefill}
//                   setValue={setGasRefill}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="cleaning">{t("ac.form.labels.cleaning")}</label> */}
//                 <label htmlFor="cleaning" className="tooltip-label">
//                                   {t("ac.form.labels.cleaning")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.cleaning.title")}
//                                     description={t("ac.tooltips.cleaning.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="cleaning"
//                   value={cleaning}
//                   setValue={setCleaning}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="issueCheckup">{t("ac.form.labels.issue_checkup")}</label> */}
//                 <label htmlFor="issueCheckup" className="tooltip-label">
//                                   {t("ac.form.labels.issue_checkup")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.issue_checkup.title")}
//                                     description={t("ac.tooltips.issue_checkup.description")}
//                                   />
//                                 </label>
//                 <select
//                   id="issueCheckup"
//                   value={issueCheckup ? "yes" : "no"}
//                   onChange={(e) => setIssueCheckup(e.target.value === "yes")}
//                 >
//                   <option value="no">{t("ac.form.labels.issue_checkup_options.no")}</option>
//                   <option value="yes">{t("ac.form.labels.issue_checkup_options.yes")}</option>
//                 </select>
//               </div>
//             </div>
//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   <span className="rebook-text">
//                     {t("ac.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("ac.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}
//             <div className="ACService-priceDisplay">
//               <span>
//                 {t("ac.form.price_display", { price: calculatePrice() })}
//               </span>
//             </div>

//             {/* Pricing note (info banner) */}
//             <div className="ACService-priceNote" role="note" aria-label={t("ac.price_note.heading")}>
//               <div className="ACService-priceNote-icon" aria-hidden="true">
//                 {/* star icon */}
//                 <svg viewBox="0 0 24 24" width="20" height="20">
//                   <path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z"/>
//                 </svg>
//               </div>
//               <div className="ACService-priceNote-content">
//                 <div className="ACService-priceNote-title">{t("ac.price_note.heading")}</div>
//                 <p className="ACService-priceNote-text">
//                   <strong>{t("ac.price_note.strong")}</strong>{" "}
//                   {t("ac.price_note.text")}
//                 </p>
//               </div>
//             </div>

//             <div className="ACService-bookingDetails">
//               <div className="ACService-optionGroup">
//                 <label htmlFor="date">{t("ac.form.labels.date")}</label>
//                 <div className="ACService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("ac.form.labels.date")}
//                     className="ACService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="ACService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(".react-datepicker__input-container input")
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="ACService-optionGroup">
//                 <label htmlFor="time">{t("ac.form.labels.time")}</label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup ACService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("ac.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("ac.form.placeholders.remarks")}
//                   className="ACService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>
//             <button type="submit" className="ACService-actionBtn">
//               {rebookState
//                 ? t("ac.form.rebook_button")
//                 : t("ac.form.book_button")}
//             </button>
//           </form>
//           <div className="ACService-infoBox">
//             <h4>{t("ac.info_box.title")}</h4>
//             <p>{t("ac.info_box.description")}</p>
//           </div>
//           <div className="ACService-additionalInfo">
//             <div className="ACService-sectionCard">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.how_to_place_order.title")}
//               </h2>
//               <ol className="ACService-stepList">
//                 {t("ac.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map((step, idx) => (
//                   <li key={idx}>{step}</li>
//                 ))}
//               </ol>
//             </div>
//             <div className="ACService-row2col">
//               <div className="ACService-sectionCard ACService-gradientBg2">
//                 <h2 className="ACService-sectionTitle">
//                   {t("ac.additional_info.why_choose_HelpNao.title")}
//                 </h2>
//                 <p className="ACService-sectionText">
//                   {t("ac.additional_info.why_choose_HelpNao.description")}
//                 </p>
//                 <div className="ACService-featureGrid">
//                   {t("ac.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map((feature, idx) => (
//                     <div key={idx} className="ACService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "balance-scale"
//                             : idx === 1
//                             ? "user-shield"
//                             : idx === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } ACService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="ACService-sectionCard ACService-gradientBg">
//                 <h2 className="ACService-sectionTitle">
//                   {t("ac.additional_info.key_features.title")}
//                 </h2>
//                 <div className="ACService-featureGrid">
//                   {t("ac.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map((feature, idx) => (
//                     <div key={idx} className="ACService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "clock"
//                             : idx === 1
//                             ? "shield-alt"
//                             : idx === 2
//                             ? "check-circle"
//                             : idx === 3
//                             ? "shield-alt"
//                             : "credit-card"
//                         } ACService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="ACService-sectionCard">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.ac_maintenance.title")}
//               </h2>
//               <div className="ACService-mdbmcbGrid">
//                 <div className="ACService-mdbmcbItem">
//                   <i
//                     className="fas fa-snowflake ACService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>{t("ac.additional_info.ac_maintenance.installation.title")}</h3>
//                     <p>{t("ac.additional_info.ac_maintenance.installation.description")}</p>
//                   </div>
//                 </div>
//                 <div className="ACService-mdbmcbItem">
//                   <i
//                     className="fas fa-tools ACService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>{t("ac.additional_info.ac_maintenance.maintenance.title")}</h3>
//                     <p>{t("ac.additional_info.ac_maintenance.maintenance.description")}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="ACService-sectionCard ACService-gradientBg3">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.order_tracking.title")}
//               </h2>
//               <div className="ACService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="ACService-sectionText ACService-centerText">
//                 {t("ac.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>
//         {showOrderForm && (
//           <ACOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>
//       <div className="ac-feedback-section">
//         <FeedbackPage serviceType="AC Service" />
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default AcService;










// ***** Add new service and update prices (21-oct-2025) ***** //

// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";
// import Select from "react-select";

// import ACOrderForm from "./ACOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import heroImage from "../images/ac-service.png";
// import "./acserviceStyle.css";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";
// import { AC_PRICING } from "../servicePricing";

// const AcService = () => {
//   const { t } = useTranslation();
//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });
//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );
//   const [useSameServitor, setUseSameServitor] = useState(false);
//   const [prevServitorName, setPrevServitorName] = useState("");
//   const [acType, setAcType] = useState("");
//   const [acTon, setAcTon] = useState("");
//   // const [newSetup, setNewSetup] = useState(0);
//   // const [installation, setInstallation] = useState(0);
//   // const [uninstallation, setUninstallation] = useState(0);
//   // const [gasRefill, setGasRefill] = useState(0);
//   // const [cleaning, setCleaning] = useState(0);

//   const [installationInside, setInstallationInside] = useState(0);
//   const [installationOutside, setInstallationOutside] = useState(0);
//   const [uninstallationInside, setUninstallationInside] = useState(0);
//   const [uninstallationOutside, setUninstallationOutside] = useState(0);

//   const [cleaningInside, setCleaningInside] = useState(0);
//   const [cleaningOutside, setCleaningOutside] = useState(0);

//   // const [issueCheckup, setIssueCheckup] = useState(false);
//   const [issueCheckupUnits, setIssueCheckupUnits] = useState(0);

//   const [remarks, setRemarks] = useState("");
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };
//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setAcType(prevOrder.acType || "");
//       setAcTon(prevOrder.acTon || "");
//       setInstallationInside(prevOrder.installation_outdoor_inside || 0); // NEW
//       setInstallationOutside(prevOrder.installation_outdoor_outside || 0); // NEW
//       setUninstallationInside(prevOrder.uninstallation_outdoor_inside || 0); // NEW
//       setUninstallationOutside(prevOrder.uninstallation_outdoor_outside || 0); // NEW

//       setCleaningInside(prevOrder.cleaning_outdoor_inside || 0); // NEW
//       setCleaningOutside(prevOrder.cleaning_outdoor_outside || 0); // NEW

//       setIssueCheckupUnits(prevOrder.issue_checkup || 0);
//       // setIssueCheckup(prevOrder.issue_checkup || false);
//       setRemarks(prevOrder.remarks || "");
//     }
//   }, [rebookState, prevOrder]);

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       const acKey = data["ac service"] || data["AC Service"] || {};
//   //       setRatingData({
//   //         reviewCount: acKey.reviewCount || 0,
//   //         avgRating: acKey.avgRating || 0,
//   //       });
//   //     })
//   //     .catch((err) => console.error("Failed to load ratings:", err));
//   // }, []);

//   useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         const acKey = data["ac service"] || data["AC Service"] || {};
//         setRatingData({
//           reviewCount: acKey.reviewCount || 0,
//           avgRating: acKey.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);

//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";
//     let startHour = startTime;
//     let startMinute = 0;
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return [];
//       }
//       if (currentHour >= startTime) {
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }
//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   //   const calculatePrice = () => {
//   //     const ton = parseFloat(acTon || "0") || 0;
//   //     const tonMult = ton >= 2 ? 1.3 : ton >= 1.5 ? 1.15 : ton >= 1 ? 1.0 : 1.0;
//   //     let price = 100;
//   //     price += newSetup * 800;
//   //     price += installation * 600;
//   //     price += uninstallation * 400;
//   //     price += gasRefill * 1200;
//   //     price += cleaning * 300;
//   //     if (issueCheckup) price += 100;
//   //     return Math.round(price * tonMult);
//   //   };

//   const tieredTotal = (count, first, additional) => {
//     const c = Math.max(0, Number(count) || 0);
//     if (c === 0) return 0;
//     if (c === 1) return first;
//     return c * additional; // 2 units -> 2 * additional
//   };

//   const calculatePrice = () => {
//     const p = AC_PRICING; // from servicePricing.js
//     let price = p.base;

//     price += tieredTotal(
//       installationInside,
//       p.perUnit.installation_outdoor_inside.first,
//       p.perUnit.installation_outdoor_inside.additional
//     );
//     price += tieredTotal(
//       installationOutside,
//       p.perUnit.installation_outdoor_outside.first,
//       p.perUnit.installation_outdoor_outside.additional
//     );

//     price += tieredTotal(
//       uninstallationInside,
//       p.perUnit.uninstallation_outdoor_inside.first,
//       p.perUnit.uninstallation_outdoor_inside.additional
//     );
//     price += tieredTotal(
//       uninstallationOutside,
//       p.perUnit.uninstallation_outdoor_outside.first,
//       p.perUnit.uninstallation_outdoor_outside.additional
//     );

//     price += tieredTotal(
//       cleaningInside,
//       p.perUnit.cleaning_outdoor_inside.first,
//       p.perUnit.cleaning_outdoor_inside.additional
//     );
//     price += tieredTotal(
//       cleaningOutside,
//       p.perUnit.cleaning_outdoor_outside.first,
//       p.perUnit.cleaning_outdoor_outside.additional
//     );

//     // checkup pricing (1–2 => 500 total; >2 => +200 each extra)
//     if (issueCheckupUnits > 0) {
//       const extra = Math.max(0, issueCheckupUnits - p.checkup.includesUnits);
//       price += p.checkup.base + extra * p.checkup.extraPerUnit;
//     }

//     return Math.round(price);
//   };

//   // ---------- NEW: Price Breakdown rows ----------
//   const breakdownRows = useMemo(() => {
//     const any =
//       installationInside > 0 ||
//       installationOutside > 0 ||
//       uninstallationInside > 0 ||
//       uninstallationOutside > 0 ||
//       cleaningInside > 0 ||
//       cleaningOutside > 0 ||
//       issueCheckupUnits > 0;

//     if (!any) return [];

//     // local helpers so eslint is happy (no missing deps)
//     const unitWord = (n) =>
//       t(n === 1 ? "ac.form.unit" : "ac.form.units", n === 1 ? "unit" : "units");
//     const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;

//     // const makeTierRow = (label, count, priceKey) => {
//     //   const c = Number(count) || 0;
//     //   if (!c) return null;
//     //   const pk = AC_PRICING.perUnit[priceKey];
//     //   const calc =
//     //     c === 1
//     //       ? `1 ${unitWord(1)} × ${fmtTk(pk.first)}`
//     //       : `${c} ${unitWord(c)} × ${fmtTk(pk.additional)}`;
//     //   const total = fmtTk(c === 1 ? pk.first : c * pk.additional);
//     //   return { label, calc, total };
//     // };

//     const makeTierRow = (label, count, priceKey) => {
//       const c = Number(count) || 0;
//       if (!c) return null;

//       const pk = AC_PRICING.perUnit[priceKey];
//       const unitPrice = c === 1 ? pk.first : pk.additional;
//       const totalNum = c === 1 ? pk.first : c * pk.additional;

//       // NOTE: keep "=" here; the <span className="ACService-breakdownTotal">
//       // will render the number after it -> "1 × 800 = 800"
//       const calc = `${c} × ${fmtTk(unitPrice)} =`;
//       const total = fmtTk(totalNum);

//       return { label, calc, total };
//     };

//     const makeCheckupRow = (units) => {
//       const c = Number(units) || 0;
//       if (!c) return null;
//       const { base, includesUnits, extraPerUnit } = AC_PRICING.checkup;

//       if (c <= includesUnits) {
//         return {
//           label: t("ac.form.labels.issue_checkup", "Issue Checkup"),
//           calc: `${c} ${unitWord(c)} — ${fmtTk(base)}`,
//           total: fmtTk(base),
//         };
//       }
//       const extra = c - includesUnits;
//       const total = base + extra * extraPerUnit;
//       return {
//         label: t("ac.form.labels.issue_checkup", "Issue Checkup"),
//         calc: `${includesUnits} ${unitWord(includesUnits)} — ${fmtTk(
//           base
//         )} + ${extra} × ${fmtTk(extraPerUnit)}`,
//         total: fmtTk(total),
//       };
//     };

//     const rows = [];

//     // Setup
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.install_in", "AC Install")} (${t(
//           "ac.breakdown.outdoor_inside",
//           "Outdoor Unit Inside"
//         )})`,
//         installationInside,
//         "installation_outdoor_inside"
//       )
//     );
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.install_out", "AC Install")} (${t(
//           "ac.breakdown.outdoor_outside",
//           "Outdoor Unit Outside"
//         )})`,
//         installationOutside,
//         "installation_outdoor_outside"
//       )
//     );

//     // Uninstall
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.uninstall_in", "AC Uninstall")} (${t(
//           "ac.breakdown.outdoor_inside",
//           "Outdoor Inside"
//         )})`,
//         uninstallationInside,
//         "uninstallation_outdoor_inside"
//       )
//     );
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.uninstall_out", "AC Uninstall")} (${t(
//           "ac.breakdown.outdoor_outside",
//           "Outdoor Outside"
//         )})`,
//         uninstallationOutside,
//         "uninstallation_outdoor_outside"
//       )
//     );

//     // Cleaning
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.clean_in", "AC Cleaning")} (${t(
//           "ac.breakdown.outdoor_inside",
//           "Outdoor Inside"
//         )})`,
//         cleaningInside,
//         "cleaning_outdoor_inside"
//       )
//     );
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.clean_out", "AC Cleaning")} (${t(
//           "ac.breakdown.outdoor_outside",
//           "Outdoor Outside"
//         )})`,
//         cleaningOutside,
//         "cleaning_outdoor_outside"
//       )
//     );

//     // Checkup
//     rows.push(makeCheckupRow(issueCheckupUnits));

//     // ✅ Booking fee LAST, and no “1 unit × …” text
//     rows.push({
//       label: t("ac.breakdown.booking_fee", "Booking Fee"),
//       calc: "", // hide calc
//       total: fmtTk(AC_PRICING.base),
//     });

//     return rows.filter(Boolean);
//   }, [
//     t,
//     installationInside,
//     installationOutside,
//     uninstallationInside,
//     uninstallationOutside,
//     cleaningInside,
//     cleaningOutside,
//     issueCheckupUnits,
//   ]);

//   const handleGetService = (e) => {
//     e.preventDefault();
//     const time = e.target.time.value;
//     const dateStr = selectedDate
//       ? selectedDate.toISOString().split("T")[0]
//       : "";
//     const formDetails = {
//       acType,
//       acTon,
//       installation_outdoor_inside: installationInside, // NEW
//       installation_outdoor_outside: installationOutside, // NEW
//       uninstallation_outdoor_inside: uninstallationInside, // NEW
//       uninstallation_outdoor_outside: uninstallationOutside, // NEW

//       cleaning_outdoor_inside: cleaningInside, // NEW
//       cleaning_outdoor_outside: cleaningOutside, // NEW
//       // issue_checkup: issueCheckup,
//       issue_checkup: issueCheckupUnits,

//       remarks,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//       useSameServitor,
//       servitor_id: useSameServitor ? prevOrder.servitor_id : undefined,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };


//   // --- AC multi-select options ---
//   const AC_TYPE_OPTIONS = [
//     { value: "Inverter",     label: "Inverter" },
//     { value: "Non-Inverter", label: "Non-Inverter" },
//   ];

//   const AC_TON_OPTIONS = [
//     { value: "1",   label: "1" },
//     { value: "1.5", label: "1.5" },
//     { value: "2",   label: "2" },
//     { value: "2.5", label: "2.5" },
//   ];


//   const handleOrderSubmit = (orderData) => {
//     console.log("Order Data:", orderData);
//     setShowOrderForm(false);
//     setAcType("");
//     setAcTon("");
//     setInstallationInside(0);
//     setInstallationOutside(0);
//     setUninstallationInside(0);
//     setUninstallationOutside(0);

//     setCleaningInside(0);
//     setCleaningOutside(0);

//     // setIssueCheckup(false);
//     setIssueCheckupUnits(0);

//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const { t } = useTranslation();
//     const handleIncrement = () => {
//       if (value < max) {
//         setValue(value + 1);
//       }
//     };
//     const handleDecrement = () => {
//       if (value > min) {
//         setValue(value - 1);
//       }
//     };
//     const displayText = `${value} ${t(
//       value === 1 ? "ac.form.unit" : "ac.form.units"
//     )}`;
//     return (
//       <div className="ACService-plusMinusInput">
//         <button
//           type="button"
//           className="ACService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="ACService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="ACService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="ACService-container">
//         <Navbar />
//         <Loader show={loading} />
//         <div className="ACService-card">
//           <div className="ACService-hero">
//             <img src={heroImage} alt="AC Services Hero" />
//           </div>
//           <div className="ACService-header">
//             <h1>
//               {rebookState ? t("ac.header.rebook_title") : t("ac.header.title")}
//             </h1>
//             <div className="ACService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="ACService-reviews">
//               {ratingData.reviewCount.toLocaleString()} {t("ac.reviewsLabel")}
//             </div>
//           </div>
//           {/* <div className="ACService-categories">
//             <div className="ACService-category">
//               <h5>
//                 <span className="ACService-categoryIcon">❄️</span>
//                 {t("ac.categories.installation.title")}
//               </h5>
//               <p className="ACService-serviceDescription">
//                 {t("ac.categories.installation.description")}
//               </p>
//             </div>
//             <div className="ACService-category">
//               <h5>
//                 <span className="ACService-categoryIcon">🛠️</span>
//                 {t("ac.categories.maintenance.title")}
//               </h5>
//               <p className="ACService-serviceDescription">
//                 {t("ac.categories.maintenance.description")}
//               </p>
//             </div>
//             <div className="ACService-category">
//               <h5>
//                 <span className="ACService-categoryIcon">🏠</span>
//                 {t("ac.categories.home_service.title")}
//               </h5>
//               <p className="ACService-serviceDescription">
//                 {t("ac.categories.home_service.description")}
//               </p>
//             </div>
//           </div> */}
//           <form onSubmit={handleGetService} className="ACService-form">
//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-snowflake"></i>
//               {t("ac.form.ac_specifics")}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="acType">{t("ac.form.labels.ac_type")}</label> */}
//                 <label htmlFor="acType" className="tooltip-label">
//                   {t("ac.form.labels.ac_type")}
//                   <ServiceTooltip
//                     title={t("ac.tooltips.ac_type.title")}
//                     description={t("ac.tooltips.ac_type.description")}
//                   />
//                 </label>
//                 {/* <select
//                   id="acType"
//                   value={acType}
//                   onChange={(e) => setAcType(e.target.value)}
//                   required
//                 >
//                   <option value="">{t("ac.form.placeholders.select")}</option>
//                   <option value="Inverter">
//                     {t("ac.form.ac_type_options.inverter")}
//                   </option>
//                   <option value="Non-Inverter">
//                     {t("ac.form.ac_type_options.non_inverter")}
//                   </option>
//                 </select> */}

//                 <Select
//                   inputId="acType"
//                   classNamePrefix="rs"
//                   isMulti
//                   placeholder={t("ac.form.placeholders.select")}
//                   options={AC_TYPE_OPTIONS}
//                   // map stored "Inverter, Non-Inverter" -> [{value,label}, ...]
//                   value={(acType || "")
//                     .split(",")
//                     .map(s => s.trim())
//                     .filter(Boolean)
//                     .map(v => AC_TYPE_OPTIONS.find(o => o.value === v) || { value: v, label: v })}
//                   // store back as comma-separated string
//                   onChange={(vals) => setAcType((vals || []).map(v => v.value).join(", "))}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="acTon">{t("ac.form.labels.ac_ton")}</label> */}
//                 <label htmlFor="acTon" className="tooltip-label">
//                   {t("ac.form.labels.ac_ton")}
//                   <ServiceTooltip
//                     title={t("ac.tooltips.ac_ton.title")}
//                     description={t("ac.tooltips.ac_ton.description")}
//                   />
//                 </label>
//                 {/* <select
//                   id="acTon"
//                   value={acTon}
//                   onChange={(e) => setAcTon(e.target.value)}
//                   required
//                 >
//                   <option value="">{t("ac.form.placeholders.select")}</option>
//                   <option value="1">1</option>
//                   <option value="1.5">1.5</option>
//                   <option value="2">2</option>
//                   <option value="2.5">2.5</option>
//                 </select> */}

//                 <Select
//                     inputId="acTon"
//                     classNamePrefix="rs"
//                     isMulti
//                     placeholder={t("ac.form.placeholders.select")}
//                     options={AC_TON_OPTIONS}
//                     // map stored "1.5, 2" -> [{value,label}, ...]
//                     value={(acTon || "")
//                       .split(",")
//                       .map(s => s.trim())
//                       .filter(Boolean)
//                       .map(v => AC_TON_OPTIONS.find(o => o.value === v) || { value: v, label: v })}
//                     // store back as comma-separated string
//                     onChange={(vals) => setAcTon((vals || []).map(v => v.value).join(", "))}
//                   />
//               </div>
//             </div>
//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-tools"></i>
//               {/* AC setup service */}
//               {t("ac.form.setup_services_title") || "AC setup service"}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="newSetup">{t("ac.form.labels.new_setup")}</label> */}
//                 <label htmlFor="newSetup" className="tooltip-label">
//                   {/* AC Install <span className="ACService-subLabel">(Outdoor Unit Inside)</span> */}
//                   {t("ac.form.labels.installation_inside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_inside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.installation_inside.title")}
//                     description={t(
//                       "ac.tooltips.installation_inside.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="installationInside"
//                   value={installationInside}
//                   setValue={setInstallationInside}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="installation">{t("ac.form.labels.installation")}</label> */}
//                 <label htmlFor="installation" className="tooltip-label">
//                   {/* AC Install <span className="ACService-subLabel">(Outdoor Unit Outside)</span> */}
//                   {t("ac.form.labels.installation_outside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_outside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.installation_outside.title")}
//                     description={t(
//                       "ac.tooltips.installation_outside.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="installationOutside"
//                   value={installationOutside}
//                   setValue={setInstallationOutside}
//                 />
//               </div>
//             </div>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="uninstallation">{t("ac.form.labels.uninstallation")}</label> */}
//                 <label htmlFor="uninstallation" className="tooltip-label">
//                   {/* AC Uninstall <span className="ACService-subLabel">(Outdoor Unit Inside)</span> */}
//                   {t("ac.form.labels.uninstallation_inside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_inside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.uninstallation_inside.title")}
//                     description={t(
//                       "ac.tooltips.uninstallation_inside.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="uninstallationInside"
//                   value={uninstallationInside}
//                   setValue={setUninstallationInside}
//                 />
//               </div>

//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="uninstallation">{t("ac.form.labels.uninstallation")}</label> */}
//                 <label htmlFor="uninstallation" className="tooltip-label">
//                   {/* AC Uninstall <span className="ACService-subLabel">(Outdoor Unit Outside)</span> */}
//                   {t("ac.form.labels.uninstallation_outside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_outside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.uninstallation_outside.title")}
//                     description={t(
//                       "ac.tooltips.uninstallation_outside.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="uninstallationOutside"
//                   value={uninstallationOutside}
//                   setValue={setUninstallationOutside}
//                 />
//               </div>
//             </div>

//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-cogs"></i>
//               {/* AC maintenance Service */}

//               {t("ac.form.maintenance_services_title") ||
//                 "AC maintenance Service"}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="gasRefill">{t("ac.form.labels.gas_refill")}</label> */}
//                 <label htmlFor="gasRefill" className="tooltip-label">
//                   {/* AC Cleaning <span className="ACService-subLabel">(Outdoor Unit Inside)</span> */}
//                   {t("ac.form.labels.cleaning_inside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_inside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.cleaning_inside.title")}
//                     description={t("ac.tooltips.cleaning_inside.description")}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="cleaningInside"
//                   value={cleaningInside}
//                   setValue={setCleaningInside}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 {/* <label htmlFor="cleaning">{t("ac.form.labels.cleaning")}</label> */}
//                 <label htmlFor="cleaning" className="tooltip-label">
//                   {/* AC Cleaning <span className="ACService-subLabel">(Outdoor Unit Outside)</span> */}
//                   {t("ac.form.labels.cleaning_outside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_outside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.cleaning_outside.title")}
//                     description={t("ac.tooltips.cleaning_outside.description")}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="cleaningOutside"
//                   value={cleaningOutside}
//                   setValue={setCleaningOutside}
//                 />
//               </div>
//               {/* <div className="ACService-optionGroup">
//                 <label htmlFor="issueCheckup" className="tooltip-label">
//                                   {t("ac.form.labels.issue_checkup")}
//                                   <ServiceTooltip
//                                     title={t("ac.tooltips.issue_checkup.title")}
//                                     description={t("ac.tooltips.issue_checkup.description")}
//                                   />
//                                 </label>
//                 <select
//                   id="issueCheckup"
//                   value={issueCheckup ? "yes" : "no"}
//                   onChange={(e) => setIssueCheckup(e.target.value === "yes")}
//                 >
//                   <option value="no">{t("ac.form.labels.issue_checkup_options.no")}</option>
//                   <option value="yes">{t("ac.form.labels.issue_checkup_options.yes")}</option>
//                 </select>
//               </div> */}

//               <div className="ACService-optionGroup">
//                 <label htmlFor="issueCheckupUnits" className="tooltip-label">
//                   {t("ac.form.labels.issue_checkup")}
//                   <span className="ACService-subLabel">
//                     ({t("ac.form.units")})
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.issue_checkup_units.title")}
//                     description={t(
//                       "ac.tooltips.issue_checkup_units.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="issueCheckupUnits"
//                   value={issueCheckupUnits}
//                   setValue={setIssueCheckupUnits}
//                   min={0}
//                 />
//                 {/* (Optional) Small hint text */}
//                 {/* <small>
//                   1–2 units cost 500 tk total; each extra unit +200 tk.
//                 </small> */}
//               </div>
//             </div>

//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   <span className="rebook-text">
//                     {t("ac.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("ac.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             {/* ---------- NEW: Price Breakdown Card ---------- */}
//             {breakdownRows.length > 0 && (
//               <div className="ACService-breakdownCard" aria-live="polite">
//                 <div className="ACService-breakdownHeader">
//                   {/* tiny calculator icon */}
//                   <svg
//                     width="18"
//                     height="18"
//                     viewBox="0 0 24 24"
//                     fill="currentColor"
//                     aria-hidden="true"
//                   >
//                     <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
//                   </svg>
//                   <span>{t("ac.breakdown.title", "Price Breakdown")}</span>
//                 </div>

//                 <ul className="ACService-breakdownList">
//                   {breakdownRows.map((row, idx) => (
//                     <li key={idx} className="ACService-breakdownRow">
//                       <span className="ACService-breakdownLabel">
//                         {row.label}
//                       </span>
//                       <span className="ACService-breakdownRight">
//                         {row.calc && (
//                           <span className="ACService-breakdownCalc">
//                             {row.calc}
//                           </span>
//                         )}
//                         <span className="ACService-breakdownTotal">
//                           {row.total}
//                         </span>
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             <div className="ACService-priceDisplay">
//               <span>
//                 {t("ac.form.price_display", { price: calculatePrice() })}
//               </span>
//             </div>

//             {/* Pricing note (info banner) */}
//             <div
//               className="ACService-priceNote"
//               role="note"
//               aria-label={t("ac.price_note.heading")}
//             >
//               <div className="ACService-priceNote-icon" aria-hidden="true">
//                 {/* star icon */}
//                 <svg viewBox="0 0 24 24" width="20" height="20">
//                   <path
//                     fill="currentColor"
//                     d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z"
//                   />
//                 </svg>
//               </div>
//               <div className="ACService-priceNote-content">
//                 <div className="ACService-priceNote-title">
//                   {t("ac.price_note.heading")}
//                 </div>
//                 <p className="ACService-priceNote-text">
//                   <strong>{t("ac.price_note.strong")}</strong>{" "}
//                   {t("ac.price_note.text")}
//                 </p>
//               </div>
//             </div>

//             <div className="ACService-bookingDetails">
//               <div className="ACService-optionGroup">
//                 <label htmlFor="date">{t("ac.form.labels.date")}</label>
//                 <div className="ACService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("ac.form.labels.date")}
//                     className="ACService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="ACService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(
//                           ".react-datepicker__input-container input"
//                         )
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="ACService-optionGroup">
//                 <label htmlFor="time">{t("ac.form.labels.time")}</label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup ACService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("ac.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("ac.form.placeholders.remarks")}
//                   className="ACService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>
//             <button type="submit" className="ACService-actionBtn">
//               {rebookState
//                 ? t("ac.form.rebook_button")
//                 : t("ac.form.book_button")}
//             </button>
//           </form>
//           <div className="ACService-infoBox">
//             <h4>{t("ac.info_box.title")}</h4>
//             <p>{t("ac.info_box.description")}</p>
//           </div>
//           <div className="ACService-additionalInfo">
//             <div className="ACService-sectionCard">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.how_to_place_order.title")}
//               </h2>
//               <ol className="ACService-stepList">
//                 {t("ac.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map((step, idx) => (
//                   <li key={idx}>{step}</li>
//                 ))}
//               </ol>
//             </div>
//             <div className="ACService-row2col">
//               <div className="ACService-sectionCard ACService-gradientBg2">
//                 <h2 className="ACService-sectionTitle">
//                   {t("ac.additional_info.why_choose_HelpNao.title")}
//                 </h2>
//                 <p className="ACService-sectionText">
//                   {t("ac.additional_info.why_choose_HelpNao.description")}
//                 </p>
//                 <div className="ACService-featureGrid">
//                   {t("ac.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map((feature, idx) => (
//                     <div key={idx} className="ACService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "balance-scale"
//                             : idx === 1
//                             ? "user-shield"
//                             : idx === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } ACService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="ACService-sectionCard ACService-gradientBg">
//                 <h2 className="ACService-sectionTitle">
//                   {t("ac.additional_info.key_features.title")}
//                 </h2>
//                 <div className="ACService-featureGrid">
//                   {t("ac.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map((feature, idx) => (
//                     <div key={idx} className="ACService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "clock"
//                             : idx === 1
//                             ? "shield-alt"
//                             : idx === 2
//                             ? "check-circle"
//                             : idx === 3
//                             ? "shield-alt"
//                             : "credit-card"
//                         } ACService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="ACService-sectionCard">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.ac_maintenance.title")}
//               </h2>
//               <div className="ACService-mdbmcbGrid">
//                 <div className="ACService-mdbmcbItem">
//                   <i
//                     className="fas fa-snowflake ACService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "ac.additional_info.ac_maintenance.installation.title"
//                       )}
//                     </h3>
//                     <p>
//                       {t(
//                         "ac.additional_info.ac_maintenance.installation.description"
//                       )}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="ACService-mdbmcbItem">
//                   <i
//                     className="fas fa-tools ACService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t("ac.additional_info.ac_maintenance.maintenance.title")}
//                     </h3>
//                     <p>
//                       {t(
//                         "ac.additional_info.ac_maintenance.maintenance.description"
//                       )}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="ACService-sectionCard ACService-gradientBg3">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.order_tracking.title")}
//               </h2>
//               <div className="ACService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="ACService-sectionText ACService-centerText">
//                 {t("ac.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>
//         {showOrderForm && (
//           <ACOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>
//       <div className="ac-feedback-section">
//         <FeedbackPage serviceType="AC Service" />
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default AcService;
// ***** Upper all code is okay and perfect working (25-nOV-2025) ***** //





// ***** New update with price and selection (25-Nov-2025) ***** //
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";
// import Select from "react-select";

// import ACOrderForm from "./ACOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import heroImage from "../images/AC-service-banner.png";
// import "./acserviceStyle.css";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";
// import { AC_PRICING } from "../servicePricing";
// import SEO from "../../../Components/SEO/SEO";

// // For tooltips
// const P = AC_PRICING;
// const rate = (key) => P?.perUnit?.[key] || { first: 0, additional: 0 };
// const discountOf = (key) => {
//   const r = rate(key);
//   return Math.max(0, (Number(r.first) || 0) - (Number(r.additional) || 0));
// };
// const CHECKUP = P?.checkup || { base: 0, includesUnits: 0, extraPerUnit: 0 };

// const AcService = () => {
//   const { t } = useTranslation();
//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });
//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );
//   const [useSameServitor, setUseSameServitor] = useState(false);
//   const [prevServitorName, setPrevServitorName] = useState("");
//   const [acType, setAcType] = useState("");
//   const [acTon, setAcTon] = useState("");

//   // error states for required selects
//   const [acTypeError, setAcTypeError] = useState(false);
//   const [acTonError, setAcTonError] = useState(false);

//   // refs for scrollIntoView
//   const acTypeRef = useRef(null);
//   const acTonRef = useRef(null);

//   const [installationInside, setInstallationInside] = useState(0);
//   const [installationOutside, setInstallationOutside] = useState(0);
//   const [uninstallationInside, setUninstallationInside] = useState(0);
//   const [uninstallationOutside, setUninstallationOutside] = useState(0);

//   const [cleaningInside, setCleaningInside] = useState(0);
//   const [cleaningOutside, setCleaningOutside] = useState(0);

//   const [issueCheckupUnits, setIssueCheckupUnits] = useState(0);

//   const [remarks, setRemarks] = useState("");
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);


//   const toLocalYMD = (d) => {
//   const x = new Date(d);
//   const y = x.getFullYear();
//   const m = String(x.getMonth() + 1).padStart(2, "0");
//   const day = String(x.getDate()).padStart(2, "0");
//   return `${y}-${m}-${day}`;
// };


//   // const getInitialDate = () => {
//   //   const now = new Date();
//   //   const currentHour = now.getHours();
//   //   if (currentHour < 7 || currentHour >= 21) {
//   //     const tomorrow = new Date();
//   //     tomorrow.setDate(now.getDate() + 1);
//   //     return tomorrow;
//   //   }
//   //   return now;
//   // };

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();

//     // before 7am or after/equal 9pm -> tomorrow
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date(now);
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };


//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setAcType(prevOrder.acType || "");
//       setAcTon(prevOrder.acTon || "");
//       setInstallationInside(prevOrder.installation_outdoor_inside || 0);
//       setInstallationOutside(prevOrder.installation_outdoor_outside || 0);
//       setUninstallationInside(prevOrder.uninstallation_outdoor_inside || 0);
//       setUninstallationOutside(prevOrder.uninstallation_outdoor_outside || 0);

//       setCleaningInside(prevOrder.cleaning_outdoor_inside || 0);
//       setCleaningOutside(prevOrder.cleaning_outdoor_outside || 0);

//       setIssueCheckupUnits(prevOrder.issue_checkup || 0);
//       setRemarks(prevOrder.remarks || "");

//       setAcTypeError(false);
//       setAcTonError(false);
//     }
//   }, [rebookState, prevOrder]);

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         const acKey = data["ac service"] || data["AC Service"] || {};
//         setRatingData({
//           reviewCount: acKey.reviewCount || 0,
//           avgRating: acKey.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);

//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     // const todayStr = now.toISOString().split("T")[0];
//     // const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     const todayStr = toLocalYMD(now);
//     const selectedDateStr = dateObj ? toLocalYMD(dateObj) : "";


//     let startHour = startTime;
//     let startMinute = 0;
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return [];
//       }
//       if (currentHour >= startTime) {
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }
//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   const tieredTotal = (count, first, additional) => {
//     const c = Math.max(0, Number(count) || 0);
//     if (c === 0) return 0;
//     if (c === 1) return first;
//     return c * additional;
//   };

//   // ✅ NEW: detect if ANY AC service / checkup is selected
//   const hasAnySelection = useMemo(() => {
//     const counts = [
//       installationInside,
//       installationOutside,
//       uninstallationInside,
//       uninstallationOutside,
//       cleaningInside,
//       cleaningOutside,
//     ];
//     const anyCount = counts.some((c) => (Number(c) || 0) > 0);
//     const hasCheckup = (Number(issueCheckupUnits) || 0) > 0;
//     return anyCount || hasCheckup;
//   }, [
//     installationInside,
//     installationOutside,
//     uninstallationInside,
//     uninstallationOutside,
//     cleaningInside,
//     cleaningOutside,
//     issueCheckupUnits,
//   ]);

//   // ✅ UPDATED: Estimated price shows 0 when nothing selected (no base fee)
//   const calculatePrice = () => {
//     const p = AC_PRICING;
//     let price = 0;

//     // Base/booking fee only when user selected something
//     if (hasAnySelection) {
//       price += p.base;
//     }

//     price += tieredTotal(
//       installationInside,
//       p.perUnit.installation_outdoor_inside.first,
//       p.perUnit.installation_outdoor_inside.additional
//     );
//     price += tieredTotal(
//       installationOutside,
//       p.perUnit.installation_outdoor_outside.first,
//       p.perUnit.installation_outdoor_outside.additional
//     );

//     price += tieredTotal(
//       uninstallationInside,
//       p.perUnit.uninstallation_outdoor_inside.first,
//       p.perUnit.uninstallation_outdoor_inside.additional
//     );
//     price += tieredTotal(
//       uninstallationOutside,
//       p.perUnit.uninstallation_outdoor_outside.first,
//       p.perUnit.uninstallation_outdoor_outside.additional
//     );

//     price += tieredTotal(
//       cleaningInside,
//       p.perUnit.cleaning_outdoor_inside.first,
//       p.perUnit.cleaning_outdoor_inside.additional
//     );
//     price += tieredTotal(
//       cleaningOutside,
//       p.perUnit.cleaning_outdoor_outside.first,
//       p.perUnit.cleaning_outdoor_outside.additional
//     );

//     if (issueCheckupUnits > 0) {
//       const extra = Math.max(0, issueCheckupUnits - p.checkup.includesUnits);
//       price += p.checkup.base + extra * p.checkup.extraPerUnit;
//     }

//     return Math.round(price);
//   };

//   // ---------- Price Breakdown rows ----------
//   const breakdownRows = useMemo(() => {
//     if (!hasAnySelection) return [];

//     const unitWord = (n) =>
//       t(n === 1 ? "ac.form.unit" : "ac.form.units", n === 1 ? "unit" : "units");
//     const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;

//     const makeTierRow = (label, count, priceKey) => {
//       const c = Number(count) || 0;
//       if (!c) return null;

//       const pk = AC_PRICING.perUnit[priceKey];
//       const unitPrice = c === 1 ? pk.first : pk.additional;
//       const totalNum = c === 1 ? pk.first : c * pk.additional;

//       const calc = `${c} × ${fmtTk(unitPrice)} =`;
//       const total = fmtTk(totalNum);

//       return { label, calc, total };
//     };

//     const makeCheckupRow = (units) => {
//       const c = Number(units) || 0;
//       if (!c) return null;
//       const { base, includesUnits, extraPerUnit } = AC_PRICING.checkup;

//       if (c <= includesUnits) {
//         return {
//           label: t("ac.form.labels.issue_checkup", "Issue Checkup"),
//           calc: `${c} ${unitWord(c)} — ${fmtTk(base)}`,
//           total: fmtTk(base),
//         };
//       }
//       const extra = c - includesUnits;
//       const total = base + extra * extraPerUnit;
//       return {
//         label: t("ac.form.labels.issue_checkup", "Issue Checkup"),
//         calc: `${includesUnits} ${unitWord(includesUnits)} — ${fmtTk(
//           base
//         )} + ${extra} × ${fmtTk(extraPerUnit)}`,
//         total: fmtTk(total),
//       };
//     };

//     const rows = [];

//     // Setup
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.install_in", "AC Install")} (${t(
//           "ac.breakdown.outdoor_inside",
//           "Outdoor Unit Inside"
//         )})`,
//         installationInside,
//         "installation_outdoor_inside"
//       )
//     );
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.install_out", "AC Install")} (${t(
//           "ac.breakdown.outdoor_outside",
//           "Outdoor Unit Outside"
//         )})`,
//         installationOutside,
//         "installation_outdoor_outside"
//       )
//     );

//     // Uninstall
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.uninstall_in", "AC Uninstall")} (${t(
//           "ac.breakdown.outdoor_inside",
//           "Outdoor Inside"
//         )})`,
//         uninstallationInside,
//         "uninstallation_outdoor_inside"
//       )
//     );
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.uninstall_out", "AC Uninstall")} (${t(
//           "ac.breakdown.outdoor_outside",
//           "Outdoor Outside"
//         )})`,
//         uninstallationOutside,
//         "uninstallation_outdoor_outside"
//       )
//     );

//     // Cleaning
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.clean_in", "AC Cleaning")} (${t(
//           "ac.breakdown.outdoor_inside",
//           "Outdoor Inside"
//         )})`,
//         cleaningInside,
//         "cleaning_outdoor_inside"
//       )
//     );
//     rows.push(
//       makeTierRow(
//         `${t("ac.breakdown.clean_out", "AC Cleaning")} (${t(
//           "ac.breakdown.outdoor_outside",
//           "Outdoor Outside"
//         )})`,
//         cleaningOutside,
//         "cleaning_outdoor_outside"
//       )
//     );

//     // Checkup
//     rows.push(makeCheckupRow(issueCheckupUnits));

//     // Booking fee row (only shown because hasAnySelection is true here)
//     rows.push({
//       // label: t("ac.breakdown.booking_fee", "Booking Fee"),
//       label: t("ac.breakdown.platform_support_fee", "Platform & Support Fee"),
//       calc: "",
//       total: fmtTk(AC_PRICING.base),
//     });

//     return rows.filter(Boolean);
//   }, [
//     t,
//     hasAnySelection,
//     installationInside,
//     installationOutside,
//     uninstallationInside,
//     uninstallationOutside,
//     cleaningInside,
//     cleaningOutside,
//     issueCheckupUnits,
//   ]);

//   const handleGetService = (e) => {
//     e.preventDefault();

//     const acTypeSelected = acType && acType.trim().length > 0;
//     const acTonSelected = acTon && acTon.trim().length > 0;

//     if (!acTypeSelected) {
//       setAcTypeError(true);
//       if (acTypeRef.current) {
//         acTypeRef.current.scrollIntoView({
//           behavior: "smooth",
//           block: "center",
//         });
//       }
//       return;
//     }

//     if (!acTonSelected) {
//       setAcTonError(true);
//       if (acTonRef.current) {
//         acTonRef.current.scrollIntoView({
//           behavior: "smooth",
//           block: "center",
//         });
//       }
//       return;
//     }

//     // extra guard (no alert, just ignore click if somehow triggered)
//     if (!hasAnySelection) return;

//     const time = e.target.time.value;
//     // const dateStr = selectedDate
//     //   ? selectedDate.toISOString().split("T")[0]
//     //   : "";

//     const dateStr = selectedDate ? toLocalYMD(selectedDate) : "";

//     const formDetails = {
//       acType,
//       acTon,
//       installation_outdoor_inside: installationInside,
//       installation_outdoor_outside: installationOutside,
//       uninstallation_outdoor_inside: uninstallationInside,
//       uninstallation_outdoor_outside: uninstallationOutside,
//       cleaning_outdoor_inside: cleaningInside,
//       cleaning_outdoor_outside: cleaningOutside,
//       issue_checkup: issueCheckupUnits,
//       remarks,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//       useSameServitor,
//       servitor_id: useSameServitor ? prevOrder.servitor_id : undefined,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // --- AC multi-select options ---
//   const AC_TYPE_OPTIONS = [
//     { value: "Inverter", label: "Inverter" },
//     { value: "Non-Inverter", label: "Non-Inverter" },
//   ];

//   const AC_TON_OPTIONS = [
//     { value: "1", label: "1" },
//     { value: "1.5", label: "1.5" },
//     { value: "2", label: "2" },
//     { value: "2.5", label: "2.5" },
//   ];

//   const handleOrderSubmit = (orderData) => {
//     // console.log("Order Data:", orderData);
//     setShowOrderForm(false);
//     setAcType("");
//     setAcTon("");
//     setInstallationInside(0);
//     setInstallationOutside(0);
//     setUninstallationInside(0);
//     setUninstallationOutside(0);
//     setCleaningInside(0);
//     setCleaningOutside(0);
//     setIssueCheckupUnits(0);
//     setRemarks("");
//     setUseSameServitor(false);
//     setAcTypeError(false);
//     setAcTonError(false);
//     setFormData({});
//   };

//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const { t } = useTranslation();
//     const handleIncrement = () => {
//       if (value < max) {
//         setValue(value + 1);
//       }
//     };
//     const handleDecrement = () => {
//       if (value > min) {
//         setValue(value - 1);
//       }
//     };
//     const displayText = `${value} ${t(
//       value === 1 ? "ac.form.unit" : "ac.form.units"
//     )}`;
//     return (
//       <div className="ACService-plusMinusInput">
//         <button
//           type="button"
//           className="ACService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="ACService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="ACService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="ACService-container">

//         <SEO
//           title="AC Service in Dhaka | Installation, Cleaning & Repair | HelpNao"
//           description="Book AC technicians for AC installation, gas recharge, deep cleaning, cooling problem fix, servicing & checkup. Reliable experts, fast booking, transparent pricing."
//           path="/services/ac-service"
//           lang="en"
//           jsonLd={{
//             "@context": "https://schema.org",
//             "@type": "Service",
//             "name": "AC Service",
//             "serviceType": "Air Conditioner Service",
//             "provider": { "@type": "Organization", "name": "HelpNao", "url": "https://helpnao.com" },
//             "areaServed": { "@type": "City", "name": "Dhaka" },
//             "hasOfferCatalog": {
//               "@type": "OfferCatalog",
//               "name": "AC Services",
//               "itemListElement": [
//                 { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Installation & Shifting" } },
//                 { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC General Service / Checkup" } },
//                 { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Deep Cleaning (Indoor & Outdoor)" } },
//                 { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Repair (Cooling/Noise/Leakage Issues)" } },
//                 { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Gas Recharge / Gas Top-up" } }
//               ]
//             }
//           }}
//         />

//         <Navbar />
//         <Loader show={loading} />
//         <div className="ACService-card">
//           <div className="ACService-hero">
//             <img src={heroImage} alt="AC Services Hero" />
//           </div>
//           <div className="ACService-header">
//             <h1>
//               {rebookState ? t("ac.header.rebook_title") : t("ac.header.title")}
//             </h1>
//             <div className="ACService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="ACService-reviews">
//               {ratingData.reviewCount.toLocaleString()} {t("ac.reviewsLabel")}
//             </div>
//           </div>

//           <form onSubmit={handleGetService} className="ACService-form">
//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-snowflake"></i>
//               {t("ac.form.ac_specifics")}
//             </h3>
//             <div className="ACService-serviceOptions">
//               {/* <div className="ACService-optionGroup" > */}
//               <div
//                 ref={acTypeRef}
//                 className={`ACService-optionGroup ${
//                   acTypeError ? "ACService-optionGroupError" : ""
//                 }`}
//               >
//                 <label htmlFor="acType" className="tooltip-label">
//                   {t("ac.form.labels.ac_type")}
//                   <ServiceTooltip
//                     title={t("ac.tooltips.ac_type.title")}
//                     description={t("ac.tooltips.ac_type.description")}
//                   />
//                 </label>
//                 <Select
//                   inputId="acType"
//                   classNamePrefix="rs"
//                   isMulti
//                   placeholder={t("ac.form.placeholders.select")}
//                   options={AC_TYPE_OPTIONS}
//                   value={(acType || "")
//                     .split(",")
//                     .map((s) => s.trim())
//                     .filter(Boolean)
//                     .map(
//                       (v) =>
//                         AC_TYPE_OPTIONS.find((o) => o.value === v) || {
//                           value: v,
//                           label: v,
//                         }
//                     )}
//                   onChange={(vals) => {
//                     setAcTypeError(false);
//                     setAcType((vals || []).map((v) => v.value).join(", "))
//                   }}
//                 />
//               </div>
//               {/* <div className="ACService-optionGroup"> */}
//               <div
//                 ref={acTonRef} 
//                 className={`ACService-optionGroup ${
//                   acTonError ? "ACService-optionGroupError" : ""
//                 }`}
//               >
//                 <label htmlFor="acTon" className="tooltip-label">
//                   {t("ac.form.labels.ac_ton")}
//                   <ServiceTooltip
//                     title={t("ac.tooltips.ac_ton.title")}
//                     description={t("ac.tooltips.ac_ton.description")}
//                   />
//                 </label>
//                 <Select
//                   inputId="acTon"
//                   classNamePrefix="rs"
//                   isMulti
//                   placeholder={t("ac.form.placeholders.select")}
//                   options={AC_TON_OPTIONS}
//                   value={(acTon || "")
//                     .split(",")
//                     .map((s) => s.trim())
//                     .filter(Boolean)
//                     .map(
//                       (v) =>
//                         AC_TON_OPTIONS.find((o) => o.value === v) || {
//                           value: v,
//                           label: v,
//                         }
//                     )}
//                   // onChange={(vals) =>
//                   //   setAcTon((vals || []).map((v) => v.value).join(", "))
//                   // }
//                   onChange={(vals) => {
//                     setAcTonError(false);
//                     setAcTon((vals || []).map((v) => v.value).join(", "));
//                   }}
//                 />
//               </div>
//             </div>

//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-tools"></i>
//               {t("ac.form.setup_services_title") || "AC setup service"}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 <label htmlFor="installationInside" className="tooltip-label">
//                   {t("ac.form.labels.installation_inside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_inside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.installation_inside.title")}
//                     description={t("ac.tooltips.installation_inside.description", {
//     first: rate("installation_outdoor_inside").first,
//     additional: rate("installation_outdoor_inside").additional,
//     discountAll: discountOf("installation_outdoor_inside"),
//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="installationInside"
//                   value={installationInside}
//                   setValue={setInstallationInside}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 <label htmlFor="installationOutside" className="tooltip-label">
//                   {t("ac.form.labels.installation_outside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_outside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.installation_outside.title")}
//                     description={t("ac.tooltips.installation_outside.description", {
//     first: rate("installation_outdoor_outside").first,
//     additional: rate("installation_outdoor_outside").additional,
//     discountAll: discountOf("installation_outdoor_outside"),

//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="installationOutside"
//                   value={installationOutside}
//                   setValue={setInstallationOutside}
//                 />
//               </div>
//             </div>

//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 <label
//                   htmlFor="uninstallationInside"
//                   className="tooltip-label"
//                 >
//                   {t("ac.form.labels.uninstallation_inside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_inside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.uninstallation_inside.title")}
//                     description={t("ac.tooltips.uninstallation_inside.description", {
//     first: rate("uninstallation_outdoor_inside").first,
//     additional: rate("uninstallation_outdoor_inside").additional,
//         discountAll: discountOf("uninstallation_outdoor_inside"),

//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="uninstallationInside"
//                   value={uninstallationInside}
//                   setValue={setUninstallationInside}
//                 />
//               </div>

//               <div className="ACService-optionGroup">
//                 <label
//                   htmlFor="uninstallationOutside"
//                   className="tooltip-label"
//                 >
//                   {t("ac.form.labels.uninstallation_outside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_outside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.uninstallation_outside.title")}
//                     description={t("ac.tooltips.uninstallation_outside.description", {
//     first: rate("uninstallation_outdoor_outside").first,
//     additional: rate("uninstallation_outdoor_outside").additional,
//     discountAll: discountOf("uninstallation_outdoor_outside"),
//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="uninstallationOutside"
//                   value={uninstallationOutside}
//                   setValue={setUninstallationOutside}
//                 />
//               </div>
//             </div>

//             <h3 className="ACService-sectionTitle">
//               <i className="fas fa-cogs"></i>
//               {t("ac.form.maintenance_services_title") ||
//                 "AC maintenance Service"}
//             </h3>
//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup">
//                 <label htmlFor="cleaningInside" className="tooltip-label">
//                   {t("ac.form.labels.cleaning_inside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_inside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.cleaning_inside.title")}
//                     description={t("ac.tooltips.cleaning_inside.description", {
//     first: rate("cleaning_outdoor_inside").first,
//     additional: rate("cleaning_outdoor_inside").additional,
//     discountAll: discountOf("cleaning_outdoor_inside"),
//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="cleaningInside"
//                   value={cleaningInside}
//                   setValue={setCleaningInside}
//                 />
//               </div>
//               <div className="ACService-optionGroup">
//                 <label htmlFor="cleaningOutside" className="tooltip-label">
//                   {t("ac.form.labels.cleaning_outside")}{" "}
//                   <span className="ACService-subLabel">
//                     {t("ac.form.sub_labels.outdoor_unit_outside")}
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.cleaning_outside.title")}
//                     description={t("ac.tooltips.cleaning_outside.description", {
//     first: rate("cleaning_outdoor_outside").first,
//     additional: rate("cleaning_outdoor_outside").additional,
//     discountAll: discountOf("cleaning_outdoor_outside"),
//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="cleaningOutside"
//                   value={cleaningOutside}
//                   setValue={setCleaningOutside}
//                 />
//               </div>

//               <div className="ACService-optionGroup">
//                 <label htmlFor="issueCheckupUnits" className="tooltip-label">
//                   {t("ac.form.labels.issue_checkup")}
//                   <span className="ACService-subLabel">
//                     ({t("ac.form.units")})
//                   </span>
//                   <ServiceTooltip
//                     title={t("ac.tooltips.issue_checkup_units.title")}
//                     description={t("ac.tooltips.issue_checkup_units.description", {
//     base: CHECKUP.base,
//     includesUnits: CHECKUP.includesUnits,
//     extraPerUnit: CHECKUP.extraPerUnit,
//   })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="issueCheckupUnits"
//                   value={issueCheckupUnits}
//                   setValue={setIssueCheckupUnits}
//                   min={0}
//                 />
//               </div>
//             </div>

//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                 <span className="rebook-text">
//                   {t("ac.form.rebook_same_servitor_prefix")}
//                   <span className="strong-name">{prevServitorName}</span>
//                   {t("ac.form.rebook_same_servitor_suffix")}
//                 </span>
//                 </label>
//               </div>
//             )}

//             {breakdownRows.length > 0 && (
//               <div className="ACService-breakdownCard" aria-live="polite">
//                 <div className="ACService-breakdownHeader">
//                   <svg
//                     width="18"
//                     height="18"
//                     viewBox="0 0 24 24"
//                     fill="currentColor"
//                     aria-hidden="true"
//                   >
//                     <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
//                   </svg>
//                   <span>{t("ac.breakdown.title", "Price Breakdown")}</span>
//                 </div>

//                 <ul className="ACService-breakdownList">
//                   {breakdownRows.map((row, idx) => (
//                     <li key={idx} className="ACService-breakdownRow">
//                       <span className="ACService-breakdownLabel">
//                         {row.label}
//                       </span>
//                       <span className="ACService-breakdownRight">
//                         {row.calc && (
//                           <span className="ACService-breakdownCalc">
//                             {row.calc}
//                           </span>
//                         )}
//                         <span className="ACService-breakdownTotal">
//                           {row.total}
//                         </span>
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             <div className="ACService-priceDisplay">
//               <span>
//                 {t("ac.form.price_display", { price: calculatePrice() })}
//               </span>
//             </div>

//             <div
//               className="ACService-priceNote"
//               role="note"
//               aria-label={t("ac.price_note.heading")}
//             >
//               <div className="ACService-priceNote-icon" aria-hidden="true">
//                 <svg viewBox="0 0 24 24" width="20" height="20">
//                   <path
//                     fill="currentColor"
//                     d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z"
//                   />
//                 </svg>
//               </div>
//               <div className="ACService-priceNote-content">
//                 <div className="ACService-priceNote-title">
//                   {t("ac.price_note.heading")}
//                 </div>
//                 <p className="ACService-priceNote-text">
//                   <strong>{t("ac.price_note.strong")}</strong>{" "}
//                   {t("ac.price_note.text")}
//                 </p>
//               </div>
//             </div>

//             <div className="ACService-bookingDetails">
//               <div className="ACService-optionGroup">
//                 <label htmlFor="date">{t("ac.form.labels.date")}</label>
//                 <div className="ACService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("ac.form.labels.date")}
//                     className="ACService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="ACService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(
//                           ".react-datepicker__input-container input"
//                         )
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="ACService-optionGroup">
//                 <label htmlFor="time">{t("ac.form.labels.time")}</label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="ACService-serviceOptions">
//               <div className="ACService-optionGroup ACService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("ac.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("ac.form.placeholders.remarks")}
//                   className="ACService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             {/* ✅ NEW: disabled while no service selected */}
//             <button
//               type="submit"
//               className="ACService-actionBtn"
//               disabled={!hasAnySelection}
//               aria-disabled={!hasAnySelection}
//             >
//               {rebookState
//                 ? t("ac.form.rebook_button")
//                 : t("ac.form.book_button")}
//             </button>
//           </form>

//           <div className="ACService-infoBox">
//             <h4>{t("ac.info_box.title")}</h4>
//             <p>{t("ac.info_box.description")}</p>
//           </div>

//           <div className="ACService-additionalInfo">
//             <div className="ACService-sectionCard">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.how_to_place_order.title")}
//               </h2>
//               <ol className="ACService-stepList">
//                 {t("ac.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map((step, idx) => (
//                   <li key={idx}>{step}</li>
//                 ))}
//               </ol>
//             </div>

//             <div className="ACService-row2col">
//               <div className="ACService-sectionCard ACService-gradientBg2">
//                 <h2 className="ACService-sectionTitle">
//                   {t("ac.additional_info.why_choose_HelpNao.title")}
//                 </h2>
//                 <p className="ACService-sectionText">
//                   {t("ac.additional_info.why_choose_HelpNao.description")}
//                 </p>
//                 <div className="ACService-featureGrid">
//                   {t("ac.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map((feature, idx) => (
//                     <div key={idx} className="ACService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "balance-scale"
//                             : idx === 1
//                             ? "user-shield"
//                             : idx === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } ACService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="ACService-sectionCard ACService-gradientBg">
//                 <h2 className="ACService-sectionTitle">
//                   {t("ac.additional_info.key_features.title")}
//                 </h2>
//                 <div className="ACService-featureGrid">
//                   {t("ac.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map((feature, idx) => (
//                     <div key={idx} className="ACService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "clock"
//                             : idx === 1
//                             ? "shield-alt"
//                             : idx === 2
//                             ? "check-circle"
//                             : idx === 3
//                             ? "credit-card"
//                             : "credit-card"
//                         } ACService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="ACService-sectionCard">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.ac_maintenance.title")}
//               </h2>
//               <div className="ACService-mdbmcbGrid">
//                 <div className="ACService-mdbmcbItem">
//                   <i
//                     className="fas fa-snowflake ACService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "ac.additional_info.ac_maintenance.installation.title"
//                       )}
//                     </h3>
//                     <p>
//                       {t(
//                         "ac.additional_info.ac_maintenance.installation.description"
//                       )}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="ACService-mdbmcbItem">
//                   <i
//                     className="fas fa-tools ACService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "ac.additional_info.ac_maintenance.maintenance.title"
//                       )}
//                     </h3>
//                     <p>
//                       {t(
//                         "ac.additional_info.ac_maintenance.maintenance.description"
//                       )}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="ACService-sectionCard ACService-gradientBg3">
//               <h2 className="ACService-sectionTitle">
//                 {t("ac.additional_info.order_tracking.title")}
//               </h2>
//               <div className="ACService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="ACService-sectionText ACService-centerText">
//                 {t("ac.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>

//         {showOrderForm && (
//           <ACOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       <div className="ac-feedback-section">
//         <FeedbackPage serviceType="AC Service" />
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default AcService;





// ***** New Update with Platform fee 5% (14-January-2026) ***** //
import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";
import Select from "react-select";

import ACOrderForm from "./ACOrderForm";
import PromptLoginCard from "../PromptLoginCard";
import FeedbackPage from "../../Feedback/FeedbackPage";
import Footer from "../../../Components/Footer/Footer";
import heroImage from "../images/AC-service-banner.png";
import "./acserviceStyle.css";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
import Loader from "../../../Components/LoaderSpin/Loader";
import { AC_PRICING } from "../servicePricing";
import SEO from "../../../Components/SEO/SEO";

// For tooltips
const P = AC_PRICING;
const rate = (key) => P?.perUnit?.[key] || { first: 0, additional: 0 };
const discountOf = (key) => {
  const r = rate(key);
  return Math.max(0, (Number(r.first) || 0) - (Number(r.additional) || 0));
};
const CHECKUP = P?.checkup || { base: 0, includesUnits: 0, extraPerUnit: 0 };

const AcService = () => {
  const { t } = useTranslation();
  const [ratingData, setRatingData] = useState({
    reviewCount: 0,
    avgRating: 0,
  });
  const location = useLocation();
  const rebookState = location.state?.fromRebook || false;
  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );
  const [useSameServitor, setUseSameServitor] = useState(false);
  const [prevServitorName, setPrevServitorName] = useState("");
  const [acType, setAcType] = useState("");
  const [acTon, setAcTon] = useState("");

  // error states for required selects
  const [acTypeError, setAcTypeError] = useState(false);
  const [acTonError, setAcTonError] = useState(false);

  // refs for scrollIntoView
  const acTypeRef = useRef(null);
  const acTonRef = useRef(null);

  const [installationInside, setInstallationInside] = useState(0);
  const [installationOutside, setInstallationOutside] = useState(0);
  const [uninstallationInside, setUninstallationInside] = useState(0);
  const [uninstallationOutside, setUninstallationOutside] = useState(0);

  const [cleaningInside, setCleaningInside] = useState(0);
  const [cleaningOutside, setCleaningOutside] = useState(0);

  const [issueCheckupUnits, setIssueCheckupUnits] = useState(0);

  const [remarks, setRemarks] = useState("");
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const toLocalYMD = (d) => {
    const x = new Date(d);
    const y = x.getFullYear();
    const m = String(x.getMonth() + 1).padStart(2, "0");
    const day = String(x.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  // const getInitialDate = () => {
  //   const now = new Date();
  //   const currentHour = now.getHours();
  //   if (currentHour < 7 || currentHour >= 21) {
  //     const tomorrow = new Date();
  //     tomorrow.setDate(now.getDate() + 1);
  //     return tomorrow;
  //   }
  //   return now;
  // };

  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();

    // before 7am or after/equal 9pm -> tomorrow
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };

  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  useEffect(() => {
    if (rebookState) {
      setAcType(prevOrder.acType || "");
      setAcTon(prevOrder.acTon || "");
      setInstallationInside(prevOrder.installation_outdoor_inside || 0);
      setInstallationOutside(prevOrder.installation_outdoor_outside || 0);
      setUninstallationInside(prevOrder.uninstallation_outdoor_inside || 0);
      setUninstallationOutside(prevOrder.uninstallation_outdoor_outside || 0);

      setCleaningInside(prevOrder.cleaning_outdoor_inside || 0);
      setCleaningOutside(prevOrder.cleaning_outdoor_outside || 0);

      setIssueCheckupUnits(prevOrder.issue_checkup || 0);
      setRemarks(prevOrder.remarks || "");

      setAcTypeError(false);
      setAcTonError(false);
    }
  }, [rebookState, prevOrder]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id.startsWith("user-")
            ? decodedToken.Id.split("user-")[1]
            : decodedToken.Id;
          const response = await axios.get(`${URL}/user/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (rebookState && prevOrder.servitor_id) {
      axios
        .get(`${URL}/servitors/${prevOrder.servitor_id}`)
        .then((res) => {
          const s = res.data;
          setPrevServitorName(`${s.FirstName} ${s.LastName}`);
        })
        .catch((err) => console.error("Error fetching servitor:", err));
    }
  }, [rebookState, prevOrder.servitor_id]);

  useEffect(() => {
    const loadRatings = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${URL}/api/ratings`);
        const acKey = data["ac service"] || data["AC Service"] || {};
        setRatingData({
          reviewCount: acKey.reviewCount || 0,
          avgRating: acKey.avgRating || 0,
        });
      } catch (err) {
        console.error("Failed to load ratings:", err);
      } finally {
        setLoading(false);
      }
    };
    loadRatings();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };

  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21;
    const slots = [];
    const now = new Date();
    // const todayStr = now.toISOString().split("T")[0];
    // const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

    const todayStr = toLocalYMD(now);
    const selectedDateStr = dateObj ? toLocalYMD(dateObj) : "";

    let startHour = startTime;
    let startMinute = 0;
    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) {
        return [];
      }
      if (currentHour >= startTime) {
        if (currentMinute > 0 && currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute > 30) {
          startHour = currentHour + 1;
          startMinute = 0;
        } else {
          startHour = currentHour;
          startMinute = 0;
        }
      }
    }
    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(
          2,
          "0"
        )} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };

  const tieredTotal = (count, first, additional) => {
    const c = Math.max(0, Number(count) || 0);
    if (c === 0) return 0;
    if (c === 1) return first;
    return c * additional;
  };

  // detect if ANY AC service / checkup is selected
  const hasAnySelection = useMemo(() => {
    const counts = [
      installationInside,
      installationOutside,
      uninstallationInside,
      uninstallationOutside,
      cleaningInside,
      cleaningOutside,
    ];
    const anyCount = counts.some((c) => (Number(c) || 0) > 0);
    const hasCheckup = (Number(issueCheckupUnits) || 0) > 0;
    return anyCount || hasCheckup;
  }, [
    installationInside,
    installationOutside,
    uninstallationInside,
    uninstallationOutside,
    cleaningInside,
    cleaningOutside,
    issueCheckupUnits,
  ]);

  const calculateSubtotal = useCallback(() => {
    const p = AC_PRICING;
    let subtotal = 0;

    subtotal += tieredTotal(
      installationInside,
      p.perUnit.installation_outdoor_inside.first,
      p.perUnit.installation_outdoor_inside.additional
    );
    subtotal += tieredTotal(
      installationOutside,
      p.perUnit.installation_outdoor_outside.first,
      p.perUnit.installation_outdoor_outside.additional
    );

    subtotal += tieredTotal(
      uninstallationInside,
      p.perUnit.uninstallation_outdoor_inside.first,
      p.perUnit.uninstallation_outdoor_inside.additional
    );
    subtotal += tieredTotal(
      uninstallationOutside,
      p.perUnit.uninstallation_outdoor_outside.first,
      p.perUnit.uninstallation_outdoor_outside.additional
    );

    subtotal += tieredTotal(
      cleaningInside,
      p.perUnit.cleaning_outdoor_inside.first,
      p.perUnit.cleaning_outdoor_inside.additional
    );
    subtotal += tieredTotal(
      cleaningOutside,
      p.perUnit.cleaning_outdoor_outside.first,
      p.perUnit.cleaning_outdoor_outside.additional
    );

    if (issueCheckupUnits > 0) {
      const extra = Math.max(0, issueCheckupUnits - p.checkup.includesUnits);
      subtotal += p.checkup.base + extra * p.checkup.extraPerUnit;
    }

    return Math.round(subtotal);
  }, [
    installationInside,
    installationOutside,
    uninstallationInside,
    uninstallationOutside,
    cleaningInside,
    cleaningOutside,
    issueCheckupUnits,
  ]);

  // UPDATED: Estimated price shows 0 when nothing selected (no base fee)
  // const calculatePrice = () => {
  //   const p = AC_PRICING;
  //   let price = 0;

  //   // Base/booking fee only when user selected something
  //   if (hasAnySelection) {
  //     price += p.base;
  //   }

  //   price += tieredTotal(
  //     installationInside,
  //     p.perUnit.installation_outdoor_inside.first,
  //     p.perUnit.installation_outdoor_inside.additional
  //   );
  //   price += tieredTotal(
  //     installationOutside,
  //     p.perUnit.installation_outdoor_outside.first,
  //     p.perUnit.installation_outdoor_outside.additional
  //   );

  //   price += tieredTotal(
  //     uninstallationInside,
  //     p.perUnit.uninstallation_outdoor_inside.first,
  //     p.perUnit.uninstallation_outdoor_inside.additional
  //   );
  //   price += tieredTotal(
  //     uninstallationOutside,
  //     p.perUnit.uninstallation_outdoor_outside.first,
  //     p.perUnit.uninstallation_outdoor_outside.additional
  //   );

  //   price += tieredTotal(
  //     cleaningInside,
  //     p.perUnit.cleaning_outdoor_inside.first,
  //     p.perUnit.cleaning_outdoor_inside.additional
  //   );
  //   price += tieredTotal(
  //     cleaningOutside,
  //     p.perUnit.cleaning_outdoor_outside.first,
  //     p.perUnit.cleaning_outdoor_outside.additional
  //   );

  //   if (issueCheckupUnits > 0) {
  //     const extra = Math.max(0, issueCheckupUnits - p.checkup.includesUnits);
  //     price += p.checkup.base + extra * p.checkup.extraPerUnit;
  //   }

  //   return Math.round(price);
  // };

  const calculatePrice = () => {
    if (!hasAnySelection) return 0;

    const subtotal = calculateSubtotal();

    const percent = Number(AC_PRICING?.platformFee?.percent ?? 0.05);
    const minFee = Number(AC_PRICING?.platformFee?.min ?? 50);

    const platformFee = Math.max(minFee, Math.round(subtotal * percent));

    return Math.round(subtotal + platformFee);
  };

  // ---------- Price Breakdown rows ----------
  const breakdownRows = useMemo(() => {
    if (!hasAnySelection) return [];

    const unitWord = (n) =>
      t(n === 1 ? "ac.form.unit" : "ac.form.units", n === 1 ? "unit" : "units");
    const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;

    const makeTierRow = (label, count, priceKey) => {
      const c = Number(count) || 0;
      if (!c) return null;

      const pk = AC_PRICING.perUnit[priceKey];
      const unitPrice = c === 1 ? pk.first : pk.additional;
      const totalNum = c === 1 ? pk.first : c * pk.additional;

      const calc = `${c} × ${fmtTk(unitPrice)} =`;
      const total = fmtTk(totalNum);

      return { label, calc, total };
    };

    const makeCheckupRow = (units) => {
      const c = Number(units) || 0;
      if (!c) return null;
      const { base, includesUnits, extraPerUnit } = AC_PRICING.checkup;

      if (c <= includesUnits) {
        return {
          label: t("ac.form.labels.issue_checkup", "Issue Checkup"),
          calc: `${c} ${unitWord(c)} — ${fmtTk(base)}`,
          total: fmtTk(base),
        };
      }
      const extra = c - includesUnits;
      const total = base + extra * extraPerUnit;
      return {
        label: t("ac.form.labels.issue_checkup", "Issue Checkup"),
        calc: `${includesUnits} ${unitWord(includesUnits)} — ${fmtTk(
          base
        )} + ${extra} × ${fmtTk(extraPerUnit)}`,
        total: fmtTk(total),
      };
    };

    const rows = [];

    // Setup
    rows.push(
      makeTierRow(
        `${t("ac.breakdown.install_in", "AC Install")} (${t(
          "ac.breakdown.outdoor_inside",
          "Outdoor Unit Inside"
        )})`,
        installationInside,
        "installation_outdoor_inside"
      )
    );
    rows.push(
      makeTierRow(
        `${t("ac.breakdown.install_out", "AC Install")} (${t(
          "ac.breakdown.outdoor_outside",
          "Outdoor Unit Outside"
        )})`,
        installationOutside,
        "installation_outdoor_outside"
      )
    );

    // Uninstall
    rows.push(
      makeTierRow(
        `${t("ac.breakdown.uninstall_in", "AC Uninstall")} (${t(
          "ac.breakdown.outdoor_inside",
          "Outdoor Inside"
        )})`,
        uninstallationInside,
        "uninstallation_outdoor_inside"
      )
    );
    rows.push(
      makeTierRow(
        `${t("ac.breakdown.uninstall_out", "AC Uninstall")} (${t(
          "ac.breakdown.outdoor_outside",
          "Outdoor Outside"
        )})`,
        uninstallationOutside,
        "uninstallation_outdoor_outside"
      )
    );

    // Cleaning
    rows.push(
      makeTierRow(
        `${t("ac.breakdown.clean_in", "AC Cleaning")} (${t(
          "ac.breakdown.outdoor_inside",
          "Outdoor Inside"
        )})`,
        cleaningInside,
        "cleaning_outdoor_inside"
      )
    );
    rows.push(
      makeTierRow(
        `${t("ac.breakdown.clean_out", "AC Cleaning")} (${t(
          "ac.breakdown.outdoor_outside",
          "Outdoor Outside"
        )})`,
        cleaningOutside,
        "cleaning_outdoor_outside"
      )
    );

    // Checkup
    rows.push(makeCheckupRow(issueCheckupUnits));

    // Booking fee row (only shown because hasAnySelection is true here)
    // rows.push({
    //   // label: t("ac.breakdown.booking_fee", "Booking Fee"),
    //   label: t("ac.breakdown.platform_support_fee", "Platform & Support Fee"),
    //   calc: "",
    //   total: fmtTk(AC_PRICING.base),
    // });

    const subtotal = calculateSubtotal();
    const percent = Number(AC_PRICING?.platformFee?.percent ?? 0.05);
    const minFee = Number(AC_PRICING?.platformFee?.min ?? 50);
    const platformFee = Math.max(minFee, Math.round(subtotal * percent));

    rows.push({
      label: t("ac.breakdown.platform_support_fee", "Platform & Support Fee"),
      // calc: `${Math.round(percent * 100)}% (min ${minFee} tk)`,
      total: fmtTk(platformFee),
    });

    return rows.filter(Boolean);
  }, [
    t,
    hasAnySelection,
    installationInside,
    installationOutside,
    uninstallationInside,
    uninstallationOutside,
    cleaningInside,
    cleaningOutside,
    issueCheckupUnits,
    calculateSubtotal,
  ]);

  const handleGetService = (e) => {
    e.preventDefault();

    const acTypeSelected = acType && acType.trim().length > 0;
    const acTonSelected = acTon && acTon.trim().length > 0;

    if (!acTypeSelected) {
      setAcTypeError(true);
      if (acTypeRef.current) {
        acTypeRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    if (!acTonSelected) {
      setAcTonError(true);
      if (acTonRef.current) {
        acTonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    // extra guard (no alert, just ignore click if somehow triggered)
    if (!hasAnySelection) return;

    const time = e.target.time.value;
    // const dateStr = selectedDate
    //   ? selectedDate.toISOString().split("T")[0]
    //   : "";

    const dateStr = selectedDate ? toLocalYMD(selectedDate) : "";

    const formDetails = {
      acType,
      acTon,
      installation_outdoor_inside: installationInside,
      installation_outdoor_outside: installationOutside,
      uninstallation_outdoor_inside: uninstallationInside,
      uninstallation_outdoor_outside: uninstallationOutside,
      cleaning_outdoor_inside: cleaningInside,
      cleaning_outdoor_outside: cleaningOutside,
      issue_checkup: issueCheckupUnits,
      remarks,
      price: calculatePrice(),
      date: dateStr,
      time,
      useSameServitor,
      servitor_id: useSameServitor ? prevOrder.servitor_id : undefined,
    };
    setFormData(formDetails);
    if (user) {
      setShowOrderForm(true);
    } else {
      setShowLoginPrompt(true);
    }
  };

  // --- AC multi-select options ---
  const AC_TYPE_OPTIONS = [
    { value: "Inverter", label: "Inverter" },
    { value: "Non-Inverter", label: "Non-Inverter" },
  ];

  const AC_TON_OPTIONS = [
    { value: "1", label: "1" },
    { value: "1.5", label: "1.5" },
    { value: "2", label: "2" },
    { value: "2.5", label: "2.5" },
  ];

  const handleOrderSubmit = (orderData) => {
    // console.log("Order Data:", orderData);
    setShowOrderForm(false);
    setAcType("");
    setAcTon("");
    setInstallationInside(0);
    setInstallationOutside(0);
    setUninstallationInside(0);
    setUninstallationOutside(0);
    setCleaningInside(0);
    setCleaningOutside(0);
    setIssueCheckupUnits(0);
    setRemarks("");
    setUseSameServitor(false);
    setAcTypeError(false);
    setAcTonError(false);
    setFormData({});
  };

  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
    const { t } = useTranslation();
    const handleIncrement = () => {
      if (value < max) {
        setValue(value + 1);
      }
    };
    const handleDecrement = () => {
      if (value > min) {
        setValue(value - 1);
      }
    };
    const displayText = `${value} ${t(
      value === 1 ? "ac.form.unit" : "ac.form.units"
    )}`;
    return (
      <div className="ACService-plusMinusInput">
        <button
          type="button"
          className="ACService-minusBtn"
          onClick={handleDecrement}
          disabled={value <= min}
        >
          −
        </button>
        <span className="ACService-valueDisplay">{displayText}</span>
        <button
          type="button"
          className="ACService-plusBtn"
          onClick={handleIncrement}
          disabled={value >= max}
        >
          +
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="ACService-container">
        <SEO
          title="AC Service in Dhaka | Installation, Cleaning & Repair | HelpNao"
          description="Book AC technicians for AC installation, gas recharge, deep cleaning, cooling problem fix, servicing & checkup. Reliable experts, fast booking, transparent pricing."
          path="/services/ac-service"
          lang="en"
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "Service",
            name: "AC Service",
            serviceType: "Air Conditioner Service",
            provider: {
              "@type": "Organization",
              name: "HelpNao",
              url: "https://helpnao.com",
            },
            areaServed: { "@type": "City", name: "Dhaka" },
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "AC Services",
              itemListElement: [
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "AC Installation & Shifting",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "AC General Service / Checkup",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "AC Deep Cleaning (Indoor & Outdoor)",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "AC Repair (Cooling/Noise/Leakage Issues)",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Gas Recharge / Gas Top-up",
                  },
                },
              ],
            },
          }}
        />

        <Navbar />
        <Loader show={loading} />
        <div className="ACService-card">
          <div className="ACService-hero">
            <img src={heroImage} alt="AC Services Hero" />
          </div>
          <div className="ACService-header">
            <h1>
              {rebookState ? t("ac.header.rebook_title") : t("ac.header.title")}
            </h1>
            <div className="ACService-rating">
              {renderStars(ratingData.avgRating)}
            </div>
            <div className="ACService-reviews">
              {ratingData.reviewCount.toLocaleString()} {t("ac.reviewsLabel")}
            </div>
          </div>

          <form onSubmit={handleGetService} className="ACService-form">
            <h3 className="ACService-sectionTitle">
              <i className="fas fa-snowflake"></i>
              {t("ac.form.ac_specifics")}
            </h3>
            <div className="ACService-serviceOptions">
              {/* <div className="ACService-optionGroup" > */}
              <div
                ref={acTypeRef}
                className={`ACService-optionGroup ${
                  acTypeError ? "ACService-optionGroupError" : ""
                }`}
              >
                <label htmlFor="acType" className="tooltip-label">
                  {t("ac.form.labels.ac_type")}
                  <ServiceTooltip
                    title={t("ac.tooltips.ac_type.title")}
                    description={t("ac.tooltips.ac_type.description")}
                  />
                </label>
                <Select
                  inputId="acType"
                  classNamePrefix="rs"
                  isMulti
                  placeholder={t("ac.form.placeholders.select")}
                  options={AC_TYPE_OPTIONS}
                  value={(acType || "")
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean)
                    .map(
                      (v) =>
                        AC_TYPE_OPTIONS.find((o) => o.value === v) || {
                          value: v,
                          label: v,
                        }
                    )}
                  onChange={(vals) => {
                    setAcTypeError(false);
                    setAcType((vals || []).map((v) => v.value).join(", "));
                  }}
                />
              </div>
              {/* <div className="ACService-optionGroup"> */}
              <div
                ref={acTonRef}
                className={`ACService-optionGroup ${
                  acTonError ? "ACService-optionGroupError" : ""
                }`}
              >
                <label htmlFor="acTon" className="tooltip-label">
                  {t("ac.form.labels.ac_ton")}
                  <ServiceTooltip
                    title={t("ac.tooltips.ac_ton.title")}
                    description={t("ac.tooltips.ac_ton.description")}
                  />
                </label>
                <Select
                  inputId="acTon"
                  classNamePrefix="rs"
                  isMulti
                  placeholder={t("ac.form.placeholders.select")}
                  options={AC_TON_OPTIONS}
                  value={(acTon || "")
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean)
                    .map(
                      (v) =>
                        AC_TON_OPTIONS.find((o) => o.value === v) || {
                          value: v,
                          label: v,
                        }
                    )}
                  // onChange={(vals) =>
                  //   setAcTon((vals || []).map((v) => v.value).join(", "))
                  // }
                  onChange={(vals) => {
                    setAcTonError(false);
                    setAcTon((vals || []).map((v) => v.value).join(", "));
                  }}
                />
              </div>
            </div>

            <h3 className="ACService-sectionTitle">
              <i className="fas fa-tools"></i>
              {t("ac.form.setup_services_title") || "AC setup service"}
            </h3>
            <div className="ACService-serviceOptions">
              <div className="ACService-optionGroup">
                <label htmlFor="installationInside" className="tooltip-label">
                  {t("ac.form.labels.installation_inside")}{" "}
                  <span className="ACService-subLabel">
                    {t("ac.form.sub_labels.outdoor_unit_inside")}
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.installation_inside.title")}
                    description={t(
                      "ac.tooltips.installation_inside.description",
                      {
                        first: rate("installation_outdoor_inside").first,
                        additional: rate("installation_outdoor_inside")
                          .additional,
                        discountAll: discountOf("installation_outdoor_inside"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="installationInside"
                  value={installationInside}
                  setValue={setInstallationInside}
                />
              </div>
              <div className="ACService-optionGroup">
                <label htmlFor="installationOutside" className="tooltip-label">
                  {t("ac.form.labels.installation_outside")}{" "}
                  <span className="ACService-subLabel">
                    {t("ac.form.sub_labels.outdoor_unit_outside")}
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.installation_outside.title")}
                    description={t(
                      "ac.tooltips.installation_outside.description",
                      {
                        first: rate("installation_outdoor_outside").first,
                        additional: rate("installation_outdoor_outside")
                          .additional,
                        discountAll: discountOf("installation_outdoor_outside"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="installationOutside"
                  value={installationOutside}
                  setValue={setInstallationOutside}
                />
              </div>
            </div>

            <div className="ACService-serviceOptions">
              <div className="ACService-optionGroup">
                <label htmlFor="uninstallationInside" className="tooltip-label">
                  {t("ac.form.labels.uninstallation_inside")}{" "}
                  <span className="ACService-subLabel">
                    {t("ac.form.sub_labels.outdoor_unit_inside")}
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.uninstallation_inside.title")}
                    description={t(
                      "ac.tooltips.uninstallation_inside.description",
                      {
                        first: rate("uninstallation_outdoor_inside").first,
                        additional: rate("uninstallation_outdoor_inside")
                          .additional,
                        discountAll: discountOf(
                          "uninstallation_outdoor_inside"
                        ),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="uninstallationInside"
                  value={uninstallationInside}
                  setValue={setUninstallationInside}
                />
              </div>

              <div className="ACService-optionGroup">
                <label
                  htmlFor="uninstallationOutside"
                  className="tooltip-label"
                >
                  {t("ac.form.labels.uninstallation_outside")}{" "}
                  <span className="ACService-subLabel">
                    {t("ac.form.sub_labels.outdoor_unit_outside")}
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.uninstallation_outside.title")}
                    description={t(
                      "ac.tooltips.uninstallation_outside.description",
                      {
                        first: rate("uninstallation_outdoor_outside").first,
                        additional: rate("uninstallation_outdoor_outside")
                          .additional,
                        discountAll: discountOf(
                          "uninstallation_outdoor_outside"
                        ),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="uninstallationOutside"
                  value={uninstallationOutside}
                  setValue={setUninstallationOutside}
                />
              </div>
            </div>

            <h3 className="ACService-sectionTitle">
              <i className="fas fa-cogs"></i>
              {t("ac.form.maintenance_services_title") ||
                "AC maintenance Service"}
            </h3>
            <div className="ACService-serviceOptions">
              <div className="ACService-optionGroup">
                <label htmlFor="cleaningInside" className="tooltip-label">
                  {t("ac.form.labels.cleaning_inside")}{" "}
                  <span className="ACService-subLabel">
                    {t("ac.form.sub_labels.outdoor_unit_inside")}
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.cleaning_inside.title")}
                    description={t("ac.tooltips.cleaning_inside.description", {
                      first: rate("cleaning_outdoor_inside").first,
                      additional: rate("cleaning_outdoor_inside").additional,
                      discountAll: discountOf("cleaning_outdoor_inside"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="cleaningInside"
                  value={cleaningInside}
                  setValue={setCleaningInside}
                />
              </div>
              <div className="ACService-optionGroup">
                <label htmlFor="cleaningOutside" className="tooltip-label">
                  {t("ac.form.labels.cleaning_outside")}{" "}
                  <span className="ACService-subLabel">
                    {t("ac.form.sub_labels.outdoor_unit_outside")}
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.cleaning_outside.title")}
                    description={t("ac.tooltips.cleaning_outside.description", {
                      first: rate("cleaning_outdoor_outside").first,
                      additional: rate("cleaning_outdoor_outside").additional,
                      discountAll: discountOf("cleaning_outdoor_outside"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="cleaningOutside"
                  value={cleaningOutside}
                  setValue={setCleaningOutside}
                />
              </div>

              <div className="ACService-optionGroup">
                <label htmlFor="issueCheckupUnits" className="tooltip-label">
                  {t("ac.form.labels.issue_checkup")}
                  <span className="ACService-subLabel">
                    ({t("ac.form.units")})
                  </span>
                  <ServiceTooltip
                    title={t("ac.tooltips.issue_checkup_units.title")}
                    description={t(
                      "ac.tooltips.issue_checkup_units.description",
                      {
                        base: CHECKUP.base,
                        includesUnits: CHECKUP.includesUnits,
                        extraPerUnit: CHECKUP.extraPerUnit,
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="issueCheckupUnits"
                  value={issueCheckupUnits}
                  setValue={setIssueCheckupUnits}
                  min={0}
                />
              </div>
            </div>

            {rebookState && prevServitorName && (
              <div className="rebook-same-servitor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameServitor}
                    onChange={() => setUseSameServitor(!useSameServitor)}
                  />
                  <span className="rebook-text">
                    {t("ac.form.rebook_same_servitor_prefix")}
                    <span className="strong-name">{prevServitorName}</span>
                    {t("ac.form.rebook_same_servitor_suffix")}
                  </span>
                </label>
              </div>
            )}

            {breakdownRows.length > 0 && (
              <div className="ACService-breakdownCard" aria-live="polite">
                <div className="ACService-breakdownHeader">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
                  </svg>
                  <span>{t("ac.breakdown.title", "Price Breakdown")}</span>
                </div>

                <ul className="ACService-breakdownList">
                  {breakdownRows.map((row, idx) => (
                    <li key={idx} className="ACService-breakdownRow">
                      <span className="ACService-breakdownLabel">
                        {row.label}
                      </span>
                      <span className="ACService-breakdownRight">
                        {row.calc && (
                          <span className="ACService-breakdownCalc">
                            {row.calc}
                          </span>
                        )}
                        <span className="ACService-breakdownTotal">
                          {row.total}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="ACService-priceDisplay">
              <span>
                {t("ac.form.price_display", { price: calculatePrice() })}
              </span>
            </div>

            <div
              className="ACService-priceNote"
              role="note"
              aria-label={t("ac.price_note.heading")}
            >
              <div className="ACService-priceNote-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    fill="currentColor"
                    d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z"
                  />
                </svg>
              </div>
              <div className="ACService-priceNote-content">
                <div className="ACService-priceNote-title">
                  {t("ac.price_note.heading")}
                </div>
                <p className="ACService-priceNote-text">
                  <strong>{t("ac.price_note.strong")}</strong>{" "}
                  {t("ac.price_note.text")}
                </p>
              </div>
            </div>

            <div className="ACService-bookingDetails">
              <div className="ACService-optionGroup">
                <label htmlFor="date">{t("ac.form.labels.date")}</label>
                <div className="ACService-dateInputWrapper">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()}
                    placeholderText={t("ac.form.labels.date")}
                    className="ACService-dateInput"
                  />
                  <FaCalendarAlt
                    className="ACService-dateIcon"
                    onClick={() =>
                      document
                        .querySelector(
                          ".react-datepicker__input-container input"
                        )
                        .click()
                    }
                  />
                </div>
              </div>
              <div className="ACService-optionGroup">
                <label htmlFor="time">{t("ac.form.labels.time")}</label>
                <select id="time" name="time" required>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="ACService-serviceOptions">
              <div className="ACService-optionGroup ACService-fullWidth">
                <label htmlFor="remarks">
                  <i className="fas fa-comment-alt"></i>
                  {t("ac.form.labels.remarks")}
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder={t("ac.form.placeholders.remarks")}
                  className="ACService-textarea"
                  rows="2"
                />
              </div>
            </div>

            {/* ✅ NEW: disabled while no service selected */}
            <button
              type="submit"
              className="ACService-actionBtn"
              disabled={!hasAnySelection}
              aria-disabled={!hasAnySelection}
            >
              {rebookState
                ? t("ac.form.rebook_button")
                : t("ac.form.book_button")}
            </button>
          </form>

          <div className="ACService-infoBox">
            <h4>{t("ac.info_box.title")}</h4>
            <p>{t("ac.info_box.description")}</p>
          </div>

          <div className="ACService-additionalInfo">
            <div className="ACService-sectionCard">
              <h2 className="ACService-sectionTitle">
                {t("ac.additional_info.how_to_place_order.title")}
              </h2>
              <ol className="ACService-stepList">
                {t("ac.additional_info.how_to_place_order.steps", {
                  returnObjects: true,
                }).map((step, idx) => (
                  <li key={idx}>{step}</li>
                ))}
              </ol>
            </div>

            <div className="ACService-row2col">
              <div className="ACService-sectionCard ACService-gradientBg2">
                <h2 className="ACService-sectionTitle">
                  {t("ac.additional_info.why_choose_HelpNao.title")}
                </h2>
                <p className="ACService-sectionText">
                  {t("ac.additional_info.why_choose_HelpNao.description")}
                </p>
                <div className="ACService-featureGrid">
                  {t("ac.additional_info.why_choose_HelpNao.features", {
                    returnObjects: true,
                  }).map((feature, idx) => (
                    <div key={idx} className="ACService-featureItem">
                      <i
                        className={`fas fa-${
                          idx === 0
                            ? "balance-scale"
                            : idx === 1
                            ? "user-shield"
                            : idx === 2
                            ? "mobile-alt"
                            : "headset"
                        } ACService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="ACService-sectionCard ACService-gradientBg">
                <h2 className="ACService-sectionTitle">
                  {t("ac.additional_info.key_features.title")}
                </h2>
                <div className="ACService-featureGrid">
                  {t("ac.additional_info.key_features.features", {
                    returnObjects: true,
                  }).map((feature, idx) => (
                    <div key={idx} className="ACService-featureItem">
                      <i
                        className={`fas fa-${
                          idx === 0
                            ? "clock"
                            : idx === 1
                            ? "shield-alt"
                            : idx === 2
                            ? "check-circle"
                            : idx === 3
                            ? "credit-card"
                            : "credit-card"
                        } ACService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="ACService-sectionCard">
              <h2 className="ACService-sectionTitle">
                {t("ac.additional_info.ac_maintenance.title")}
              </h2>
              <div className="ACService-mdbmcbGrid">
                <div className="ACService-mdbmcbItem">
                  <i
                    className="fas fa-snowflake ACService-mdbmcbIcon"
                    aria-hidden="true"
                  ></i>
                  <div>
                    <h3>
                      {t(
                        "ac.additional_info.ac_maintenance.installation.title"
                      )}
                    </h3>
                    <p>
                      {t(
                        "ac.additional_info.ac_maintenance.installation.description"
                      )}
                    </p>
                  </div>
                </div>
                <div className="ACService-mdbmcbItem">
                  <i
                    className="fas fa-tools ACService-mdbmcbIcon"
                    aria-hidden="true"
                  ></i>
                  <div>
                    <h3>
                      {t("ac.additional_info.ac_maintenance.maintenance.title")}
                    </h3>
                    <p>
                      {t(
                        "ac.additional_info.ac_maintenance.maintenance.description"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="ACService-sectionCard ACService-gradientBg3">
              <h2 className="ACService-sectionTitle">
                {t("ac.additional_info.order_tracking.title")}
              </h2>
              <div className="ACService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="ACService-sectionText ACService-centerText">
                {t("ac.additional_info.order_tracking.description")}
              </p>
            </div>
          </div>
        </div>

        {showOrderForm && (
          <ACOrderForm
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            formData={formData}
            user={user}
            previousServitorName={prevServitorName}
          />
        )}
        {showLoginPrompt && (
          <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
        )}
      </div>

      <div className="ac-feedback-section">
        <FeedbackPage serviceType="AC Service" />
      </div>
      <Footer />
    </>
  );
};

export default AcService;